
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("iVuOI", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $1qfLF = parcelRequire("1qfLF");


var $efXed = parcelRequire("efXed");











var $3654r = parcelRequire("3654r");


var $3gadb = parcelRequire("3gadb");


var $6F6hl = parcelRequire("6F6hl");


var $lcVz9 = parcelRequire("lcVz9");


var $i63G2 = parcelRequire("i63G2");

const $b9184c4c52835b15$export$d9c2d067feb61447 = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $4pOgL.isReactCompilerActivePlatform)() ? function ThemedIconButton(t0, ref) {
    const $ = (0, $frIzR.c)(14);
    let Icon;
    let label;
    let props;
    let tooltip;
    if ($[0] !== t0) {
        ({ icon: Icon, label: label, tooltip: tooltip, ...props } = t0);
        $[0] = t0;
        $[1] = Icon;
        $[2] = label;
        $[3] = props;
        $[4] = tooltip;
    } else {
        Icon = $[1];
        label = $[2];
        props = $[3];
        tooltip = $[4];
    }
    const t1 = tooltip?.content ?? label;
    let t2;
    if ($[5] !== Icon || $[6] !== label || $[7] !== props || $[8] !== ref) {
        t2 = (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $i63G2.ThemedPressable), {
                ...props,
                shape: "square",
                ref: (0, $3654r.default)([
                    ref,
                    triggerProps.ref
                ]),
                onClick: (event, analyticsEvent)=>{
                    props.onClick?.(event, analyticsEvent);
                    triggerProps?.onClick?.(event);
                },
                onMouseOver: (e)=>{
                    triggerProps.onMouseOver?.(e);
                    props.onMouseOver?.(e);
                },
                onMouseOut: (e_0)=>{
                    triggerProps.onMouseOut?.(e_0);
                    props.onMouseOut?.(e_0);
                },
                onMouseMove: (e_1)=>{
                    triggerProps.onMouseMove?.(e_1);
                    props.onMouseMove?.(e_1);
                },
                onMouseDown: (e_2)=>{
                    triggerProps.onMouseDown?.(e_2);
                    props.onMouseDown?.(e_2);
                },
                onFocus: (e_3)=>{
                    triggerProps.onFocus?.(e_3);
                    props.onFocus?.(e_3);
                },
                onBlur: (e_4)=>{
                    triggerProps.onBlur?.(e_4);
                    props.onBlur?.(e_4);
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lcVz9.default), {
                icon: Icon
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6F6hl.default), null, label));
        $[5] = Icon;
        $[6] = label;
        $[7] = props;
        $[8] = ref;
        $[9] = t2;
    } else t2 = $[9];
    let t3;
    if ($[10] !== t1 || $[11] !== t2 || $[12] !== tooltip) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            ...tooltip,
            content: t1
        }, t2);
        $[10] = t1;
        $[11] = t2;
        $[12] = tooltip;
        $[13] = t3;
    } else t3 = $[13];
    return t3;
} : function ThemedIconButton({ icon: Icon, label: label, tooltip: tooltip, ...props }, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        ...tooltip,
        content: tooltip?.content ?? label
    }, (triggerProps)=>/**
     * The `aria-describedby` from `triggerProps` is intentionally not passed down,
     * because it would cause double announcements with the `VisuallyHidden` label.
     *
     * The `@atlaskit/button` IconButton uses the same approach.
     */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $i63G2.ThemedPressable), {
            ...props,
            shape: "square",
            ref: (0, $3654r.default)([
                ref,
                triggerProps.ref
            ]),
            onClick: (event, analyticsEvent)=>{
                props.onClick?.(event, analyticsEvent);
                triggerProps?.onClick?.(event);
            },
            onMouseOver: (e)=>{
                triggerProps.onMouseOver?.(e);
                props.onMouseOver?.(e);
            },
            onMouseOut: (e_0)=>{
                triggerProps.onMouseOut?.(e_0);
                props.onMouseOut?.(e_0);
            },
            onMouseMove: (e_1)=>{
                triggerProps.onMouseMove?.(e_1);
                props.onMouseMove?.(e_1);
            },
            onMouseDown: (e_2)=>{
                triggerProps.onMouseDown?.(e_2);
                props.onMouseDown?.(e_2);
            },
            onFocus: (e_3)=>{
                triggerProps.onFocus?.(e_3);
                props.onFocus?.(e_3);
            },
            onBlur: (e_4)=>{
                triggerProps.onBlur?.(e_4);
                props.onBlur?.(e_4);
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lcVz9.default), {
            icon: Icon
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6F6hl.default), null, label)));
});


const $c0fb28ab7385a39b$export$c25acd513dcc8062 = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $4pOgL.isReactCompilerActivePlatform)() ? (props, ref)=>{
    const $ = (0, $frIzR.c)(4);
    const hasCustomTheme = (0, $efXed.useHasCustomTheme)();
    const Component = hasCustomTheme ? (0, $b9184c4c52835b15$export$d9c2d067feb61447) : (0, $1qfLF.default);
    let t0;
    if ($[0] !== Component || $[1] !== props || $[2] !== ref) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Component, {
            ref: ref,
            ...props
        });
        $[0] = Component;
        $[1] = props;
        $[2] = ref;
        $[3] = t0;
    } else t0 = $[3];
    return t0;
} : (props, ref)=>{
    const hasCustomTheme = (0, $efXed.useHasCustomTheme)();
    const Component = hasCustomTheme ? (0, $b9184c4c52835b15$export$d9c2d067feb61447) : (0, $1qfLF.default);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Component, {
        ref: ref,
        ...props
    });
});
module.exports["IconButton"] = $c0fb28ab7385a39b$export$c25acd513dcc8062;

});

parcelRegister("8zs3p", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $9gVcn = parcelRequire("9gVcn");

const $a2cec1783d8c9bc6$export$8b40a725a91166de = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(2);
    const isFhsEnabled = (0, $42omo.useContext)((0, $9gVcn.IsFhsEnabledContext));
    let t0;
    if ($[0] !== isFhsEnabled) {
        t0 = typeof isFhsEnabled === "boolean" ? isFhsEnabled : isFhsEnabled();
        $[0] = isFhsEnabled;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : ()=>{
    const isFhsEnabled = (0, $42omo.useContext)((0, $9gVcn.IsFhsEnabledContext));
    return typeof isFhsEnabled === 'boolean' ? isFhsEnabled : isFhsEnabled();
};
module.exports["useIsFhsEnabled"] = $a2cec1783d8c9bc6$export$8b40a725a91166de;

});

parcelRegister("9gVcn", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");

const $2af2b85cff10a1fc$export$1e91b29ada71c32a = /*#__PURE__*/ (0, $42omo.createContext)(()=>(0, $dh538.fg)('navx-full-height-sidebar'));
module.exports["IsFhsEnabledContext"] = $2af2b85cff10a1fc$export$1e91b29ada71c32a;

});

parcelRegister("bssir", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $fFa3V = parcelRequire("fFa3V");


var $jTxSS = parcelRequire("jTxSS");


var $dRnqM = parcelRequire("dRnqM");


var $c0qxy = parcelRequire("c0qxy");


var $g6aM3 = parcelRequire("g6aM3");


var $6UUmP = parcelRequire("6UUmP");


var $bSjaC = parcelRequire("bSjaC");


var $4T4vf = parcelRequire("4T4vf");




var $l0s1Q = parcelRequire("l0s1Q");




var $5X6QO = parcelRequire("5X6QO");


var $gZctg = parcelRequire("gZctg");


var $3gadb = parcelRequire("3gadb");


var $5CLwS = parcelRequire("5CLwS");


var $6F6hl = parcelRequire("6F6hl");


var $8zs3p = parcelRequire("8zs3p");


var $K0HEo = parcelRequire("K0HEo");

function $5c11e49c5c74abb4$export$3d412b3011b66f82(resizeBound) {
    if (resizeBound.endsWith('vw')) {
        // Max width was provided in `vw` units, so is relative to the viewport width.
        // e.g. 50vw = 50% of the viewport width.
        // `parseInt` will remove the `vw` suffix.
        const maxWidthFraction = parseInt(resizeBound) / 100;
        return Math.floor(window.innerWidth * maxWidthFraction);
    }
    // Max width was provided in `px` units, so we can parse it directly.
    // `parseInt` will remove the `px` suffix.
    return Math.floor(parseInt(resizeBound));
}


function $dff022be7a6bc7d7$export$b5423678cdf09f5({ currentWidth: currentWidth, resizeBounds: resizeBounds }) {
    const resizeRange = resizeBounds.max - resizeBounds.min;
    const widthAsPercentage = (currentWidth - resizeBounds.min) / resizeRange * 100;
    if (widthAsPercentage < 0) return 0;
    if (widthAsPercentage > 100) return 100;
    return Math.floor(widthAsPercentage);
}


/**
 * Returns the computed width of an element in pixels.
 */ const $490f158999f382d6$export$d942790ad00c41f9 = (element)=>{
    // Always returns an integer. Returns 0 if element is hidden / removed.
    return element.offsetWidth;
};


const $4ecf0f02c5a418f1$export$e360234971cb95b8 = ({ initialWidth: initialWidth, location: location, initialClientX: initialClientX, direction: direction, position: position })=>{
    const diffX = location.current.input.clientX - initialClientX;
    // Resize line is positioned at the inline-end (right) of the element.
    // If the direction is left-to-right, the width will increase when the mouse is moved to the right, and vice versa.
    if (position === 'end') return direction === 'ltr' ? initialWidth + diffX : initialWidth - diffX;
    // Resize line is positioned at the inline-start (left) of the element.
    // If the direction is left-to-right, the width will decrease when the mouse is moved to the right, and vice versa.
    return direction === 'ltr' ? initialWidth - diffX : initialWidth + diffX;
};



var $5By30 = parcelRequire("5By30");

/**
 * The debounce time for the PanelSplitter resize callback functions.
 *
 * - For `onResizeStart`, it will call the callback immediately, but not
 * again until the user stops resizing and this wait time has passed.
 * - For `onResizeEnd`, it will call the callback only after this time has
 * passed since the last resize event.
 */ const $b29e9f9401610bc8$var$resizeCallbackDebounceTimeMs = 500;
function $b29e9f9401610bc8$export$f7d3d5dae65f74aa({ onResizeStart: onResizeStart, onResizeEnd: onResizeEnd }) {
    let resizingState = {
        type: 'idle'
    };
    /**
   * Starts a timer to reset the state to idle and call `onResizeEnd` after a wait time.
   */ function startResizeEndTimer({ initialWidth: initialWidth, finalWidth: finalWidth }) {
        const markResizeAsEndedTimeout = setTimeout(()=>{
            onResizeEnd({
                initialWidth: initialWidth,
                finalWidth: finalWidth
            });
            resizingState = {
                type: 'idle'
            };
        }, $b29e9f9401610bc8$var$resizeCallbackDebounceTimeMs);
        resizingState = {
            type: 'resizing',
            initialWidth: initialWidth,
            abort () {
                clearTimeout(markResizeAsEndedTimeout);
            }
        };
    }
    function onResize({ initialWidth: initialWidth, finalWidth: finalWidth }) {
        if (resizingState.type === 'idle') {
            // If the state was idle, this counts as a resize start event.
            onResizeStart({
                initialWidth: initialWidth
            });
            startResizeEndTimer({
                initialWidth: initialWidth,
                finalWidth: finalWidth
            });
            return;
        }
        if (resizingState.type === 'resizing') {
            // If the state was already resizing, clear the existing timeout and start a new one.
            resizingState.abort();
            startResizeEndTimer({
                initialWidth: resizingState.initialWidth,
                finalWidth: finalWidth
            });
            return;
        }
    }
    return {
        onResize: onResize
    };
}



var $2KODV = parcelRequire("2KODV");


var $1D5qM = parcelRequire("1D5qM");


var $4YRks = parcelRequire("4YRks");

function $0765ebec7270ae85$var$signPanelSplitterDragData(data) {
    return {
        ...data,
        [(0, $4YRks.panelSplitterDragDataSymbol)]: true
    };
}
const $0765ebec7270ae85$var$containerStyles = {
    root: "_12ji1r31 _1qu2glyw _12y31o36 _1e0cglyw _kqswstnw _u7coidpf _152tidpf _1pbykb7n _181n1ule",
    positionEnd: "_rjxpftgi",
    positionStart: "_1e02zeo2"
};
const $0765ebec7270ae85$var$grabAreaStyles = {
    root: "_1bsbl52n _4t3i1osq _kqswstnw _1q51ze3t _y4tize3t _85i5ze3t _bozgze3t _syaz1j28 _bfhk1j28 _1oec6ebc _1lww188d _6fl41ytf _k8m01ylx _d0aluf7j _vp7g6x5g _30l36x5g _1gglglyw _9h8h12zz",
    fullHeightSidebar: "_d0al11mm"
};
const $0765ebec7270ae85$var$lineStyles = {
    root: "_kqswstnw _1e0c1ule _1bsb1l7b _4t3i1osq _syaz1kw7 _bfhk1r31 _1e021v6z"
};
const $0765ebec7270ae85$var$tooltipStyles = {
    root: "_ahbq196n _1bsb1ris"
};
const $0765ebec7270ae85$var$PanelSplitterTooltip = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $4pOgL.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $frIzR.c)(18);
    let children;
    let className;
    let props;
    if ($[0] !== t0) {
        ({ children: children, className: className, ...props } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = className;
        $[3] = props;
    } else {
        children = $[1];
        className = $[2];
        props = $[3];
    }
    let t1;
    bb0: {
        if (!props.style || !props.style.transform) {
            t1 = props.style;
            break bb0;
        }
        let t2;
        if ($[4] !== props.style.transform) {
            let t3;
            if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
                t3 = /(?:-|\+)?\d*\.?\d+px/g;
                $[6] = t3;
            } else t3 = $[6];
            t2 = props.style.transform.matchAll(t3);
            $[4] = props.style.transform;
            $[5] = t2;
        } else t2 = $[5];
        const [translateX, translateY] = t2;
        if (!translateY) {
            t1 = props.style;
            break bb0;
        }
        const newTranslateY = `max(calc(${(0, $K0HEo.contentInsetBlockStart)} + ${"var(--ds-space-100, 8px)"}), ${translateY})`;
        const newTransform = `translate3d(${translateX}, ${newTranslateY}, 0)`;
        let t3;
        if ($[7] !== newTransform || $[8] !== props.style) {
            t3 = {
                ...props.style,
                transform: newTransform
            };
            $[7] = newTransform;
            $[8] = props.style;
            $[9] = t3;
        } else t3 = $[9];
        t1 = t3;
    }
    const style = t1;
    let t2;
    if ($[10] !== className) {
        t2 = (0, $gMc0m.default)([
            $0765ebec7270ae85$var$tooltipStyles.root,
            className
        ]);
        $[10] = className;
        $[11] = t2;
    } else t2 = $[11];
    let t3;
    if ($[12] !== children || $[13] !== props || $[14] !== ref || $[15] !== style || $[16] !== t2) {
        t3 = /*#__PURE__*/ $42omo.createElement((0, $5CLwS.default), {
            ...props,
            ref: ref,
            className: t2,
            style: style
        }, children);
        $[12] = children;
        $[13] = props;
        $[14] = ref;
        $[15] = style;
        $[16] = t2;
        $[17] = t3;
    } else t3 = $[17];
    return t3;
} : ({ children: children, className: className, ...props }, ref)=>{
    const style = (0, $42omo.useMemo)(()=>{
        if (!props.style || !props.style.transform) return props.style;
         // We cannot just match against integers safely, as browsers may introduce non-integer values due to scaling
        // In the future we can probably use `CSSStyleValue.parse()` to get the browser to handle parsing for us,
        // but there's no Firefox support yet.
        const [translateX, translateY] = props.style.transform.matchAll(/(?:-|\+)?\d*\.?\d+px/g);
        if (!translateY) // If we can't extract the translateY value we bail out and return the original style
        return props.style;
         /**
       * Adjusts the translate Y to keep the tooltip within the main content area,
       * so that it does not appear over the banner or top navigation.
       */ 
        const newTranslateY = `max(calc(${(0, $K0HEo.contentInsetBlockStart)} + ${"var(--ds-space-100, 8px)"}), ${translateY})`;
        const newTransform = `translate3d(${translateX}, ${newTranslateY}, 0)`;
        return {
            ...props.style,
            transform: newTransform
        };
    }, [
        props.style
    ]);
    return /*#__PURE__*/ $42omo.createElement((0, $5CLwS.default), {
        ...props,
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/design-system/no-unsafe-style-overrides
        className: (0, $gMc0m.default)([
            $0765ebec7270ae85$var$tooltipStyles.root,
            className
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: style
    }, children);
}); /**
     * A wrapper component that renders a tooltip if the tooltipContent or shortcut is provided.
     */ 
const $0765ebec7270ae85$var$MaybeTooltip = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(5);
    const { tooltipContent: tooltipContent, shortcut: shortcut, children: children, testId: testId } = t0;
    const isFhsEnabled = (0, $8zs3p.useIsFhsEnabled)();
    if (tooltipContent && isFhsEnabled) {
        let t1;
        if ($[0] !== children || $[1] !== shortcut || $[2] !== testId || $[3] !== tooltipContent) {
            t1 = /*#__PURE__*/ $42omo.createElement((0, $3gadb.default), {
                testId: testId,
                content: tooltipContent,
                shortcut: shortcut,
                position: "mouse-y",
                mousePosition: "right",
                isScreenReaderAnnouncementDisabled: true,
                component: $0765ebec7270ae85$var$PanelSplitterTooltip,
                shouldAlwaysFadeIn: true,
                shouldRenderToParent: true
            }, children);
            $[0] = children;
            $[1] = shortcut;
            $[2] = testId;
            $[3] = tooltipContent;
            $[4] = t1;
        } else t1 = $[4];
        return t1;
    }
    return children;
} : ({ tooltipContent: tooltipContent, shortcut: shortcut, children: children, testId: testId })=>{
    const isFhsEnabled = (0, $8zs3p.useIsFhsEnabled)();
    if (tooltipContent && isFhsEnabled) return /*#__PURE__*/ $42omo.createElement((0, $3gadb.default), {
        testId: testId,
        content: tooltipContent,
        shortcut: shortcut,
        position: "mouse-y",
        mousePosition: "right",
        isScreenReaderAnnouncementDisabled: true,
        component: $0765ebec7270ae85$var$PanelSplitterTooltip,
        shouldAlwaysFadeIn: true,
        shouldRenderToParent: true
    }, children);
    return children;
};
function $0765ebec7270ae85$var$getTextDirection(element) {
    const { direction: direction } = window.getComputedStyle(element);
    return direction === 'rtl' ? 'rtl' : 'ltr';
}
const $0765ebec7270ae85$var$PortaledPanelSplitter = ({ label: label, onResizeStart: onResizeStart, onResizeEnd: onResizeEnd, testId: testId, panelId: panelId, panelWidth: panelWidth, onCompleteResize: onCompleteResize, getResizeBounds: getResizeBounds, panel: panel, portal: portal, resizingCssVar: resizingCssVar, position: position, tooltipContent: tooltipContent, shortcut: shortcut })=>{
    const isFhsEnabled = (0, $8zs3p.useIsFhsEnabled)();
    const splitterRef = (0, $42omo.useRef)(null);
    const labelId = (0, $c0qxy.useId)(); // Separate state used for the input range width to remove the UI's dependency on the "persisted" layout state value being updated
    const [rangeInputValue, setRangeInputValue] = (0, $42omo.useState)(panelWidth); /**
                                                                       * We are using state to store the resize bounds _converted into pixel units_, so that we can update them when the window is resized.
                                                                       * Otherwise they can become out of sync with the actual viewport size, and cause a broken experience (inaccurate width percentage)
                                                                       * when the user tries to resize using the keyboard.
                                                                       */ 
    const [rangeInputBounds, setRangeInputBounds] = (0, $42omo.useState)({
        // Using placeholder values here for the initial render. These will be calculated and updated when the range input is focused.
        min: 200,
        max: 500
    });
    const openLayerObserver = (0, $6UUmP.useOpenLayerObserver)(); /**
                                                     * This is a temporary workaround to enable the `SideNavPanelSplitter` component
                                                     * to collapse the side nav on double click, without exposing the `onDoubleClick` prop on `PanelSplitter`.
                                                     * Once `PanelSplitter` supports an `onDoubleClick` prop directly, this context can be removed.
                                                     */ 
    const onDoubleClick = (0, $42omo.useContext)((0, $2KODV.OnDoubleClickContext)); // Storing the initial `clientX` on `mousedown` events, to workaround a bug caused by some browser extensions
    // where the `dragstart` event incorrectly returns `0` for the `clientX` location.
    const initialClientXRef = (0, $42omo.useRef)(null);
    (0, $42omo.useEffect)(()=>{
        const splitter = splitterRef.current;
        (0, $dRnqM.default)(splitter, 'Splitter ref must be set');
        return (0, $bSjaC.combine)((0, $l0s1Q.blockDraggingToIFrames)({
            element: splitter
        }), /**
     * Capturing the initial `clientX` from the mousedown, before the drag starts.
     *
     * ⚠️ Note: We are not using pragmatic-drag-and-drop's `onDragStart` for this as some browser
     * extensions can cause the client location (e.g. clientX) to incorrectly return 0 during the `dragstart` event.
     *
     * We are also not using pragmatic-drag-and-drop's `onDrag` here as it is throttled, which means
     * fast mouse movements can cause the real first drag event to be missed, causing a different clientX
     * to be captured.
     *
     * I also tried only binding an event listener inside pragmatic-drag-and-drop's `onDragStart`, which seemd to work
     * but did not feel as robust, and might have timing issues as it happens slightly later.
     */ (0, $fFa3V.bind)(splitter, {
            type: 'mousedown',
            listener: (event)=>{
                initialClientXRef.current = event.clientX;
            }
        }), (0, $4T4vf.draggable)({
            element: splitter,
            onGenerateDragPreview: ({ nativeSetDragImage: nativeSetDragImage })=>{
                // We will be moving the line to indicate a drag. We can disable the native drag preview
                (0, $5X6QO.disableNativeDragPreview)({
                    nativeSetDragImage: nativeSetDragImage
                }); // We don't want any native drop animation for when the user does not drop on a drop target. We want the drag to finish immediately
                (0, $gZctg.preventUnhandled).start();
            },
            getInitialData () {
                const initialWidth = (0, $490f158999f382d6$export$d942790ad00c41f9)(panel); /**
                                                    * The drag calculations require the actual computed width of the element
                                                    * For example, if the panel has loaded with a width of 2000px, but the max bound is 1000px and is visually 1000px (due to the CSS `clamp()`),
                                                    * the drag calculations should use the actual width of 1000px, not the width in state of 2000px.
                                                    */ 
                return $0765ebec7270ae85$var$signPanelSplitterDragData({
                    panelId: panelId,
                    initialWidth: initialWidth,
                    resizingWidth: `${initialWidth}px`,
                    resizeBounds: getResizeBounds(),
                    // Only computing text direction when we need it, just as the drag is starting.
                    // Recomputing text direction on each new drag in case the text direction
                    // has changed. This is unlikely, but being safe.
                    direction: $0765ebec7270ae85$var$getTextDirection(panel)
                });
            },
            onDragStart ({ source: source }) {
                /**
         * ⚠️ Note: We are not using the client locations (e.g. clientX) during `onDragStart`
         * because some browser extensions can cause the event properties to incorrectly return 0.
         */ (0, $dRnqM.default)((0, $5By30.isPanelSplitterDragData)(source.data));
                onResizeStart?.({
                    initialWidth: source.data.initialWidth
                }); // Close any open layers when the user starts resizing
                openLayerObserver?.closeLayers();
            },
            onDrag ({ location: location, source: source_0 }) {
                /**
         * ⚠️ Note: We are not using the location.initial.input client locations because some browser extensions
         * can cause the client locations (e.g. clientX) in the `dragstart` event to incorrectly return 0.
         */ (0, $dRnqM.default)((0, $5By30.isPanelSplitterDragData)(source_0.data));
                const { initialWidth: initialWidth_0, resizeBounds: resizeBounds, direction: direction } = source_0.data;
                (0, $dRnqM.default)(initialClientXRef.current !== null, 'initialClientX must be set'); /**
                                                                                      * How wide the element would be if there were no width constraints,
                                                                                      * based on the pointer's position.
                                                                                      */ 
                const targetWidth = (0, $4ecf0f02c5a418f1$export$e360234971cb95b8)({
                    initialWidth: initialWidth_0,
                    location: location,
                    // The fallback of 0 won't be used due to the invariant, however we require one to satisfy the type.
                    initialClientX: initialClientXRef.current ?? 0,
                    direction: direction,
                    position: position
                });
                const resizingWidth = `clamp(${resizeBounds.min}, ${targetWidth}px, ${resizeBounds.max})`;
                panel.style.setProperty(resizingCssVar, resizingWidth);
                source_0.data.resizingWidth = resizingWidth;
            },
            onDrop ({ source: source_1 }) {
                (0, $dRnqM.default)((0, $5By30.isPanelSplitterDragData)(source_1.data));
                (0, $gZctg.preventUnhandled).stop();
                const finalWidth = (0, $490f158999f382d6$export$d942790ad00c41f9)(panel);
                onCompleteResize(finalWidth);
                onResizeEnd?.({
                    initialWidth: source_1.data.initialWidth,
                    finalWidth: finalWidth
                });
                panel.style.removeProperty(resizingCssVar);
            }
        }));
    }, [
        onCompleteResize,
        onResizeStart,
        onResizeEnd,
        panel,
        resizingCssVar,
        panelWidth,
        position,
        openLayerObserver,
        panelId,
        getResizeBounds
    ]);
    const onResizeStartStableRef = (0, $g6aM3.default)(onResizeStart);
    const onResizeEndStableRef = (0, $g6aM3.default)(onResizeEnd);
    const [keyboardResizeManager] = (0, $42omo.useState)(()=>(0, $b29e9f9401610bc8$export$f7d3d5dae65f74aa)({
            onResizeStart: (...args)=>{
                // Close any open layers when the user starts resizing with keyboard
                openLayerObserver?.closeLayers();
                onResizeStartStableRef.current?.(...args);
            },
            onResizeEnd: (...args_0)=>onResizeEndStableRef.current?.(...args_0)
        }));
    const handleSliderInputChange = (0, $42omo.useCallback)((event_0)=>{
        const value = parseInt(event_0.target.value);
        setRangeInputValue(value); /**
                                * We are intentionally _not_ debouncing `onCompleteResize` as we want it to be called anytime the user changes the range input value.
                                * It is an internal-only callback - it's provided by `PanelSplitterProvider`, and used by layout slots to update their layout width state.
                                */ 
        onCompleteResize(value);
        keyboardResizeManager.onResize({
            initialWidth: panelWidth,
            finalWidth: value
        });
    }, [
        onCompleteResize,
        panelWidth,
        keyboardResizeManager
    ]);
    const resizeEventListenerCleanupFn = (0, $42omo.useRef)(null);
    const handleSliderFocus = (0, $42omo.useCallback)(()=>{
        /**
     * We are only updating the range input's properties when the element is focused, as a performance optimisation.
     * It isn't necessary to recalculate these values until the element is going to be used.
     */ // Clean up any left over listeners in case `focus` was triggered again without `blur`.
        resizeEventListenerCleanupFn.current?.(); // Update the range input value to match the current panel width.
        setRangeInputValue(panelWidth);
        const resizeBounds_0 = getResizeBounds(); // Update the range input bounds to ensure they are accurate (in case the viewport was previously resized)
        setRangeInputBounds({
            min: (0, $5c11e49c5c74abb4$export$3d412b3011b66f82)(resizeBounds_0.min),
            max: (0, $5c11e49c5c74abb4$export$3d412b3011b66f82)(resizeBounds_0.max)
        }); /**
         * _While the slider element is focused_, add a window resize event listener to update the range input bounds
         * when the window is resized. This is needed to ensure the min and max widths accurately reflect the viewport
         * size - in case they are provided in vw units.
         *
         * This listener is cleaned up when the element is blurred.
         */ 
        resizeEventListenerCleanupFn.current = (0, $fFa3V.bind)(window, {
            type: 'resize',
            listener: function updateState() {
                const resizeBounds_1 = getResizeBounds();
                setRangeInputBounds({
                    min: (0, $5c11e49c5c74abb4$export$3d412b3011b66f82)(resizeBounds_1.min),
                    max: (0, $5c11e49c5c74abb4$export$3d412b3011b66f82)(resizeBounds_1.max)
                });
            }
        });
    }, [
        panelWidth,
        getResizeBounds
    ]);
    const handleSliderBlur = (0, $42omo.useCallback)(()=>{
        // Remove the resize event listener when the range input is blurred.
        resizeEventListenerCleanupFn.current?.();
    }, []);
    (0, $42omo.useEffect)(()=>{
        return function cleanup() {
            // Cleanup the resize event listener when the component is unmounted.
            resizeEventListenerCleanupFn.current?.();
        };
    }, []);
    const ariaValueText = (0, $42omo.useMemo)(()=>`${(0, $dff022be7a6bc7d7$export$b5423678cdf09f5)({
            currentWidth: rangeInputValue,
            resizeBounds: rangeInputBounds
        })}% width`, [
        rangeInputValue,
        rangeInputBounds
    ]);
    return /*#__PURE__*/ (0, $jTxSS.createPortal)(/*#__PURE__*/ $42omo.createElement("div", {
        "data-testid": testId ? `${testId}-container` : undefined,
        className: (0, $gMc0m.default)([
            $0765ebec7270ae85$var$containerStyles.root,
            position === 'start' && $0765ebec7270ae85$var$containerStyles.positionStart,
            position === 'end' && $0765ebec7270ae85$var$containerStyles.positionEnd
        ])
    }, /*#__PURE__*/ $42omo.createElement($0765ebec7270ae85$var$MaybeTooltip, {
        tooltipContent: tooltipContent,
        shortcut: shortcut,
        testId: testId ? `${testId}-tooltip` : undefined
    }, /*#__PURE__*/ $42omo.createElement("div", {
        ref: splitterRef,
        "data-testid": testId,
        onDoubleClick: onDoubleClick,
        className: (0, $gMc0m.default)([
            $0765ebec7270ae85$var$grabAreaStyles.root,
            isFhsEnabled && $0765ebec7270ae85$var$grabAreaStyles.fullHeightSidebar
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $6F6hl.default), null, /*#__PURE__*/ $42omo.createElement("input", {
        type: "range",
        value: rangeInputValue,
        step: 20,
        min: rangeInputBounds.min,
        max: rangeInputBounds.max,
        "aria-valuetext": ariaValueText,
        "aria-labelledby": labelId,
        onChange: handleSliderInputChange,
        onFocus: handleSliderFocus,
        onBlur: handleSliderBlur
    }), /*#__PURE__*/ $42omo.createElement("span", {
        id: labelId
    }, label)), /*#__PURE__*/ $42omo.createElement("span", {
        className: (0, $gMc0m.default)([
            $0765ebec7270ae85$var$lineStyles.root
        ])
    })))), portal);
};
const $0765ebec7270ae85$export$db67e3f8d3d6da0f = ({ label: label, onResizeStart: onResizeStart, onResizeEnd: onResizeEnd, testId: testId, tooltipContent: tooltipContent })=>{
    const [panel, setPanel] = (0, $42omo.useState)(null);
    const [portal, setPortal] = (0, $42omo.useState)(null);
    const context = (0, $42omo.useContext)((0, $1D5qM.PanelSplitterContext));
    (0, $dRnqM.default)(context, 'Panel splitter context not set');
    const { panelRef: panelRef, portalRef: portalRef, isEnabled: isEnabled, panelId: panelId, panelWidth: panelWidth, onCompleteResize: onCompleteResize, getResizeBounds: getResizeBounds, resizingCssVar: resizingCssVar, position: position, shortcut: shortcut } = context; /**
                * **Explanation**
                *
                * _How React Suspense works_
                *
                * When a component is suspended:
                *
                * - it is _not_ "unmounted" and effects are _not_ cleaned up
                * - refs to react managed elements are cleared
                * - react adds `display:none !important` as an inline style to hide the element
                * - state is preserved
                *
                * When a suspended component is resumed:
                * - `display:none !important` inline style is removed
                * - it will re-render (without the refs set)
                * - refs will be set
                * - `useEffect` will _not_ re-run
                *
                * [More details](https://x.com/alexandereardon/status/1944617494569992440)
                *
                * _What does this mean for the panel splitter?_
                *
                * - The panel splitter renders into content into a react managed element (eg managed by Aside)
                * - When UI is suspended the portal ref is cleared
                * - After a suspense, we will get a render with cleared refs
                * - 🔥 This is problematic if we want to portal into that ref during the render
                *
                * _Approach: initial render_
                *
                * - We cannot portal the panel splitter until after the refs are initially set
                * - Effects run after refs being set. In an effect we set the ref values (which are populated),
                *   trigger a re-render and then portal into the refs.
                *
                * _Approach: suspense_
                *
                * - We put the refs into react `state` after every render
                * - The refs in `state` will not be cleared by suspending as effects are not run, or cleaned up,
                *   when components are suspended / resumed.
                * - After the post suspense render, we can use the `portalRef` (which was captured in an effect)
                *   to continue to portal into.
                *
                * _Why not store `portalRef` in `state` in `<PanelSplitterProvider>`?_
                *
                * - The `portalRef` is set high in the tree, so a re-render will cause a
                *   large amount of components to re-render (eg the whole sidebar)
                * - After a suspense, we would need to do _another_ large re-render to propagate the new refs
                * - With our current approach, any changes to `portalRef` will cause a re-render low in the tree
                *   (just in the `<PanelSplitter>`)
                */ 
    // We want this effect to run after each render (see above)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $42omo.useEffect)(()=>{
        // Don't need to do anything
        if (!isEnabled) return;
         // It is safe to access refs in useEffect, even with Suspense
        const panelEl = panelRef.current;
        const portalEl = portalRef.current;
        (0, $dRnqM.default)(panelEl, 'panelRef not set');
        (0, $dRnqM.default)(portalEl, 'portal element not set'); // Doing our own check, as this results in fewer re-renders than react
        // (which also does it's own checks to see if a re-render should occur)
        if (panelEl === panel && portalEl === portal) return;
         // If refs don't change, react won't cause infinite loops
        setPanel(panelEl);
        setPortal(portalEl);
    });
    if (!isEnabled) return null;
    if (!portal || !panel) return null;
    return /*#__PURE__*/ $42omo.createElement($0765ebec7270ae85$var$PortaledPanelSplitter, {
        label: label,
        onResizeStart: onResizeStart,
        onResizeEnd: onResizeEnd,
        testId: testId,
        panelId: panelId,
        panel: panel,
        portal: portal,
        panelWidth: panelWidth,
        onCompleteResize: onCompleteResize,
        getResizeBounds: getResizeBounds,
        resizingCssVar: resizingCssVar,
        position: position,
        tooltipContent: tooltipContent,
        shortcut: shortcut
    });
};
module.exports["PanelSplitter"] = $0765ebec7270ae85$export$db67e3f8d3d6da0f;

});

parcelRegister("K0HEo", function(module, exports) {
/**
 * These variables are shared across the different page layout slots.
 * This violates the [UI styling standard](https://atlassian.design/components/eslint-plugin-ui-styling-standard/no-imported-style-values/usage).
 * We have chosen to ignore this rule to prevent duplicating them across the different slots, and to provide a high level view of them and how they relate.
 */ // These are "compressed" to discourage usage.
const $6a2ece5716de6726$export$951bf5156e86d974 = '--n_sNvw';
const $6a2ece5716de6726$export$594e6a30db7c057e = '--n_asDw';
const $6a2ece5716de6726$export$db0c2e1d744fb281 = '--n_pnlW';
const $6a2ece5716de6726$export$515a0b1baafe906c = '--n_bnrM';
const $6a2ece5716de6726$export$60ef3a7b1ed42328 = '--n_tNvM';
const $6a2ece5716de6726$export$a16bbd599f6269e7 = '--n_rbnW';
const $6a2ece5716de6726$export$1216dacffd1e9e65 = '--n_sNvlw';
const $6a2ece5716de6726$export$5db28b16b6e686bc = Symbol('SideNav PanelSplitter');
const $6a2ece5716de6726$export$de580d653bac8ad9 = Symbol('Aside PanelSplitter');
const $6a2ece5716de6726$export$3452dcb65711af44 = Symbol('Panel PanelSplitter');
const $6a2ece5716de6726$export$2874e68531ce3163 = `calc(100vh - var(--n_bnrM, 0px) - var(--n_tNvM, 0px))`;
const $6a2ece5716de6726$export$bfabd8c2c572ad29 = `calc(var(--n_bnrM, 0px) + var(--n_tNvM, 0px))`;
const $6a2ece5716de6726$export$855f5a09f5c99ac = '--topNavigationHeight';
const $6a2ece5716de6726$export$26354f9814213292 = '--bannerHeight';
const $6a2ece5716de6726$export$6bfc931a04ec5741 = '--leftSidebarWidth';
const $6a2ece5716de6726$export$58de0a46980ca7f4 = '--leftPanelWidth';
const $6a2ece5716de6726$export$bbbace2ff0c7ae1b = '--rightSidebarWidth';
const $6a2ece5716de6726$export$753bf7651b25db91 = '--rightPanelWidth';
const $6a2ece5716de6726$export$6460bd6a2446260 = `calc(var(${$6a2ece5716de6726$export$26354f9814213292}, 0px) + var(${$6a2ece5716de6726$export$855f5a09f5c99ac}, 0px))`;
const $6a2ece5716de6726$export$3055529fab2b4edf = `calc(var(${$6a2ece5716de6726$export$58de0a46980ca7f4}, 0px) + var(${$6a2ece5716de6726$export$6bfc931a04ec5741}, 0px))`;
const $6a2ece5716de6726$export$166d8fd766c3eb92 = `calc(var(${$6a2ece5716de6726$export$bbbace2ff0c7ae1b}, 0px) + var(${$6a2ece5716de6726$export$753bf7651b25db91}, 0px))`;
const $6a2ece5716de6726$export$61156ceb1a99f6a0 = {
    ribbon: 4,
    // The side nav panel splitter is layered above the top nav when FHS is enabled.
    // It has the same z-index value, but is rendered after the top nav in the DOM so is stacked above.
    sideNavPanelSplitterFHS: 4,
    topBar: 4,
    banner: 4,
    // When FHS is enabled, the side nav is layered below the top nav,
    // but above the panel
    bannerFHS: 3,
    topNavFHS: 3,
    sideNav: 2,
    panelSmallViewports: 1
};
const $6a2ece5716de6726$export$876effa8b02edc2f = 'side-nav';
const $6a2ece5716de6726$export$a6be839a92c90df7 = 'top-nav-start';
const $6a2ece5716de6726$export$762ad20d97870b35 = 'top-nav-middle';
const $6a2ece5716de6726$export$8dd71e8a7db48024 = 'top-nav-end';
module.exports["sideNavVar"] = $6a2ece5716de6726$export$951bf5156e86d974;
module.exports["panelVar"] = $6a2ece5716de6726$export$db0c2e1d744fb281;
module.exports["bannerMountedVar"] = $6a2ece5716de6726$export$515a0b1baafe906c;
module.exports["topNavMountedVar"] = $6a2ece5716de6726$export$60ef3a7b1ed42328;
module.exports["sideNavLiveWidthVar"] = $6a2ece5716de6726$export$1216dacffd1e9e65;
module.exports["sideNavPanelSplitterId"] = $6a2ece5716de6726$export$5db28b16b6e686bc;
module.exports["panelPanelSplitterId"] = $6a2ece5716de6726$export$3452dcb65711af44;
module.exports["contentInsetBlockStart"] = $6a2ece5716de6726$export$bfabd8c2c572ad29;
module.exports["UNSAFE_topNavVar"] = $6a2ece5716de6726$export$855f5a09f5c99ac;
module.exports["UNSAFE_bannerVar"] = $6a2ece5716de6726$export$26354f9814213292;
module.exports["UNSAFE_sideNavLayoutVar"] = $6a2ece5716de6726$export$6bfc931a04ec5741;
module.exports["UNSAFE_panelLayoutVar"] = $6a2ece5716de6726$export$753bf7651b25db91;
module.exports["UNSAFE_MAIN_BLOCK_START_FOR_LEGACY_PAGES_ONLY"] = $6a2ece5716de6726$export$6460bd6a2446260;
module.exports["openLayerObserverSideNavNamespace"] = $6a2ece5716de6726$export$876effa8b02edc2f;
module.exports["openLayerObserverTopNavStartNamespace"] = $6a2ece5716de6726$export$a6be839a92c90df7;
module.exports["openLayerObserverTopNavMiddleNamespace"] = $6a2ece5716de6726$export$762ad20d97870b35;
module.exports["openLayerObserverTopNavEndNamespace"] = $6a2ece5716de6726$export$8dd71e8a7db48024;

});

parcelRegister("1fdQV", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");


var $jTxSS = parcelRequire("jTxSS");


var $inPa6 = parcelRequire("inPa6");


var $3654r = parcelRequire("3654r");


var $g6aM3 = parcelRequire("g6aM3");


var $fQcKS = parcelRequire("fQcKS");

var $6UUmP = parcelRequire("6UUmP");


var $dh538 = parcelRequire("dh538");


var $4T4vf = parcelRequire("4T4vf");


var $bWLcG = parcelRequire("bWLcG");


var $3RzOP = parcelRequire("3RzOP");


var $5o2qn = parcelRequire("5o2qn");


var $8zs3p = parcelRequire("8zs3p");


var $K0HEo = parcelRequire("K0HEo");


var $9w5su = parcelRequire("9w5su");


var $8jREP = parcelRequire("8jREP");


var $c9vFp = parcelRequire("c9vFp");


var $d4FF7 = parcelRequire("d4FF7");


var $38bxn = parcelRequire("38bxn");


var $5KskV = parcelRequire("5KskV");

// Note: this value has been pulled into a separate file to better
// support testing with Playwright. Playwright did not like importing
// an exported value from `sidenav.tsx` which has `@jsxRuntime classic`.
//
// Error:
// > importSource cannot be set when runtime is classic.
/**
 * How long the flyout should remain open after the users
 * pointer has left the side nav flyout
 */ const $b9b280e8233788f4$export$a7801e29f563faad = 400;



var $1w9Ty = parcelRequire("1w9Ty");


var $8SLJH = parcelRequire("8SLJH");


var $huiud = parcelRequire("huiud");


var $hEvVF = parcelRequire("hEvVF");


var $1cuAd = parcelRequire("1cuAd");


var $iCTy4 = parcelRequire("iCTy4");


var $ijWqx = parcelRequire("ijWqx");


























var $622t3 = parcelRequire("622t3");

const $51a0d9035b4b4171$export$f762e7ac9d86adb0 = (0, $4pOgL.isReactCompilerActivePlatform)() ? function useSideNavToggleKeyboardShortcut(t0) {
    const $ = (0, $frIzR.c)(8);
    const { canToggleWithShortcut: canToggleWithShortcut } = t0;
    const isFhsEnabled = (0, $8zs3p.useIsFhsEnabled)();
    const openLayerObserver = (0, $6UUmP.useOpenLayerObserver)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            trigger: "keyboard"
        };
        $[0] = t1;
    } else t1 = $[0];
    const toggleVisibilityByShortcut = (0, $622t3.useToggleSideNav)(t1);
    const canToggleWithShortcutStableRef = (0, $g6aM3.default)(canToggleWithShortcut);
    const isSideNavShortcutEnabled = (0, $iCTy4.useIsSideNavShortcutEnabled)();
    let t2;
    let t3;
    if ($[1] !== canToggleWithShortcutStableRef || $[2] !== isFhsEnabled || $[3] !== isSideNavShortcutEnabled || $[4] !== openLayerObserver || $[5] !== toggleVisibilityByShortcut) {
        t2 = ()=>{
            if (!isFhsEnabled) return;
            if (!isSideNavShortcutEnabled) return;
            return (0, $fFa3V.bind)(window, {
                type: "keydown",
                listener (event) {
                    if (event.ctrlKey && event.key === "[") {
                        if (canToggleWithShortcutStableRef.current && !canToggleWithShortcutStableRef.current()) return;
                        if (event.repeat) return;
                        if (openLayerObserver && openLayerObserver.getCount({
                            type: "modal"
                        }) > 0) return;
                        openLayerObserver?.closeLayers();
                        toggleVisibilityByShortcut();
                    }
                }
            });
        };
        t3 = [
            canToggleWithShortcutStableRef,
            isFhsEnabled,
            isSideNavShortcutEnabled,
            openLayerObserver,
            toggleVisibilityByShortcut
        ];
        $[1] = canToggleWithShortcutStableRef;
        $[2] = isFhsEnabled;
        $[3] = isSideNavShortcutEnabled;
        $[4] = openLayerObserver;
        $[5] = toggleVisibilityByShortcut;
        $[6] = t2;
        $[7] = t3;
    } else {
        t2 = $[6];
        t3 = $[7];
    }
    (0, $42omo.useEffect)(t2, t3);
} : function useSideNavToggleKeyboardShortcut({ canToggleWithShortcut: canToggleWithShortcut }) {
    const isFhsEnabled = (0, $8zs3p.useIsFhsEnabled)();
    const openLayerObserver = (0, $6UUmP.useOpenLayerObserver)();
    const toggleVisibilityByShortcut = (0, $622t3.useToggleSideNav)({
        trigger: 'keyboard'
    });
    const canToggleWithShortcutStableRef = (0, $g6aM3.default)(canToggleWithShortcut);
    const isSideNavShortcutEnabled = (0, $iCTy4.useIsSideNavShortcutEnabled)();
    (0, $42omo.useEffect)(()=>{
        if (!isFhsEnabled) return;
        if (!isSideNavShortcutEnabled) return;
        return (0, $fFa3V.bind)(window, {
            type: 'keydown',
            listener (event) {
                if (event.ctrlKey && event.key === '[') {
                    if (canToggleWithShortcutStableRef.current && !canToggleWithShortcutStableRef.current()) // Return early if the callback returns false.
                    // If the callback is not provided, we assume the shortcut is enabled.
                    return;
                    if (event.repeat) // Ignore repeated keydown events from holding down the keys
                    return;
                    if (openLayerObserver && openLayerObserver.getCount({
                        type: 'modal'
                    }) > 0) // Return early if there are any open modals
                    return;
                    openLayerObserver?.closeLayers();
                    toggleVisibilityByShortcut();
                }
            }
        });
    }, [
        canToggleWithShortcutStableRef,
        isFhsEnabled,
        isSideNavShortcutEnabled,
        openLayerObserver,
        toggleVisibilityByShortcut
    ]);
};



var $7R2w7 = parcelRequire("7R2w7");











var $bzNqF = parcelRequire("bzNqF");

const $f521bee41562bd5b$export$1904b8f2577aba9a = (0, $4pOgL.isReactCompilerActivePlatform)() ? function useSideNavVisibilityCallbacks(t0) {
    const $ = (0, $frIzR.c)(14);
    const { onExpand: onExpand, onCollapse: onCollapse, isExpandedOnDesktop: isExpandedOnDesktop, isExpandedOnMobile: isExpandedOnMobile, lastTrigger: lastTrigger } = t0;
    const onExpandRef = (0, $42omo.useRef)(onExpand);
    const onCollapseRef = (0, $42omo.useRef)(onCollapse);
    let t1;
    let t2;
    if ($[0] !== onCollapse || $[1] !== onExpand) {
        t1 = ()=>{
            onExpandRef.current = onExpand;
            onCollapseRef.current = onCollapse;
        };
        t2 = [
            onExpand,
            onCollapse
        ];
        $[0] = onCollapse;
        $[1] = onExpand;
        $[2] = t1;
        $[3] = t2;
    } else {
        t1 = $[2];
        t2 = $[3];
    }
    (0, $42omo.useEffect)(t1, t2);
    const previousIsExpandedOnDesktop = (0, $bzNqF.default)(isExpandedOnDesktop);
    let t3;
    let t4;
    if ($[4] !== isExpandedOnDesktop || $[5] !== lastTrigger || $[6] !== previousIsExpandedOnDesktop) {
        t3 = ()=>{
            if (previousIsExpandedOnDesktop === undefined || previousIsExpandedOnDesktop === isExpandedOnDesktop) return;
            if (isExpandedOnDesktop) onExpandRef.current?.({
                screen: "desktop",
                trigger: lastTrigger
            });
            else onCollapseRef.current?.({
                screen: "desktop",
                trigger: lastTrigger
            });
        };
        t4 = [
            previousIsExpandedOnDesktop,
            isExpandedOnDesktop,
            lastTrigger
        ];
        $[4] = isExpandedOnDesktop;
        $[5] = lastTrigger;
        $[6] = previousIsExpandedOnDesktop;
        $[7] = t3;
        $[8] = t4;
    } else {
        t3 = $[7];
        t4 = $[8];
    }
    (0, $42omo.useEffect)(t3, t4);
    const previousIsExpandedOnMobile = (0, $bzNqF.default)(isExpandedOnMobile);
    let t5;
    let t6;
    if ($[9] !== isExpandedOnMobile || $[10] !== lastTrigger || $[11] !== previousIsExpandedOnMobile) {
        t5 = ()=>{
            if (previousIsExpandedOnMobile === undefined || previousIsExpandedOnMobile === isExpandedOnMobile) return;
            if (isExpandedOnMobile) onExpandRef.current?.({
                screen: "mobile",
                trigger: lastTrigger
            });
            else onCollapseRef.current?.({
                screen: "mobile",
                trigger: lastTrigger
            });
        };
        t6 = [
            previousIsExpandedOnMobile,
            isExpandedOnMobile,
            lastTrigger
        ];
        $[9] = isExpandedOnMobile;
        $[10] = lastTrigger;
        $[11] = previousIsExpandedOnMobile;
        $[12] = t5;
        $[13] = t6;
    } else {
        t5 = $[12];
        t6 = $[13];
    }
    (0, $42omo.useEffect)(t5, t6);
} : function useSideNavVisibilityCallbacks({ onExpand: onExpand, onCollapse: onCollapse, isExpandedOnDesktop: isExpandedOnDesktop, isExpandedOnMobile: isExpandedOnMobile, lastTrigger: lastTrigger }) {
    // Wrapping in refs so we can call them in `useEffect` without changes to them triggering the `useEffect`
    const onExpandRef = (0, $42omo.useRef)(onExpand);
    const onCollapseRef = (0, $42omo.useRef)(onCollapse);
    (0, $42omo.useEffect)(()=>{
        onExpandRef.current = onExpand;
        onCollapseRef.current = onCollapse;
    }, [
        onExpand,
        onCollapse
    ]);
    const previousIsExpandedOnDesktop = (0, $bzNqF.default)(isExpandedOnDesktop);
    (0, $42omo.useEffect)(()=>{
        if (previousIsExpandedOnDesktop === undefined || previousIsExpandedOnDesktop === isExpandedOnDesktop) /**
       * The previous value is `undefined` on initialization, so if it is `undefined` then the value hasn't changed.
       *
       * The previous value can be equal to the current one if the component re-renders due to something else changing.
       *
       * In both cases the value hasn't changed and we don't want to notify consumers.
       */ return;
        if (isExpandedOnDesktop) onExpandRef.current?.({
            screen: 'desktop',
            trigger: lastTrigger
        });
        else onCollapseRef.current?.({
            screen: 'desktop',
            trigger: lastTrigger
        });
    }, [
        previousIsExpandedOnDesktop,
        isExpandedOnDesktop,
        lastTrigger
    ]);
    const previousIsExpandedOnMobile = (0, $bzNqF.default)(isExpandedOnMobile);
    (0, $42omo.useEffect)(()=>{
        if (previousIsExpandedOnMobile === undefined || previousIsExpandedOnMobile === isExpandedOnMobile) /**
       * The previous value is `undefined` on initialization, so if it is `undefined` then the value hasn't changed.
       *
       * The previous value can be equal to the current one if the component re-renders due to something else changing.
       *
       * In both cases the value hasn't changed and we don't want to notify consumers.
       */ return;
        if (isExpandedOnMobile) onExpandRef.current?.({
            screen: 'mobile',
            trigger: lastTrigger
        });
        else onCollapseRef.current?.({
            screen: 'mobile',
            trigger: lastTrigger
        });
    }, [
        previousIsExpandedOnMobile,
        isExpandedOnMobile,
        lastTrigger
    ]);
};





const $897ab7f8a2e9a596$var$panelSplitterResizingVar = '--n_snvRsz'; // Used to share the side nav width with the panel splitter, which is rendered outside the side nav element
// but positioned to stay at its right edge.
const $897ab7f8a2e9a596$var$sideNavClampedWidthVar = '--n_snvW';
const $897ab7f8a2e9a596$var$widthResizeBounds = {
    min: '240px',
    max: '50vw'
};
function $897ab7f8a2e9a596$var$getResizeBounds() {
    return $897ab7f8a2e9a596$var$widthResizeBounds;
} /**
   * We are using JS to detect Firefox and disable animations, instead of using CSS, as Compiled currently does not merge duplicate
   * CSS at-rules when at-rules are nested: https://github.com/atlassian-labs/compiled/blob/e04a325915e1d13010205089e4915de0e53bc2d4/packages/css/src/plugins/merge-duplicate-at-rules.ts#L5
   * Avoiding nesting the `@supports` at-rule inside of `@media` means Compiled can remove duplicate styles from the generated CSS.
   */ 
const $897ab7f8a2e9a596$var$isFirefox = typeof navigator !== 'undefined' && navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
const $897ab7f8a2e9a596$var$panelSplitterPortalTargetStyles = {
    root: "_kqsw1n9t _1pbyegat _u7coidpf _t9ectl5p _4t3ieqxy _165t56xv _p0az1elq"
};
const $897ab7f8a2e9a596$var$styles = {
    root: "_nd5l1b6c _191wglyw _t51zglyw _bfhk1bhr _16qs130s _vchhusvi _4t3ieqxy _152timx3 _kqsw1if8 _1bsb1ego _1pbycs5v _14b5hc79 _qilnk0mc _p5clia51 _4ap3vuon _scbpglyw",
    flyoutOpen: "_qiln1gzg _p5clglyw _4ap31bhr _scbp130s _139f8iot _1tpvfnf5 _sylc1a5r _oyeijq3t",
    flyoutAnimateClosed: "_1e0cglyw _qiln1gzg _139f8iot _1tpvfnf5 _sylc1a5r _1uwsjq3t",
    animationRTLSupport: "_15yekb7n _65m41mrw",
    flyoutBaseStylesFullHeightSidebar: "_qiln1gzg _p5clglyw _4ap31bhr _scbp130s _17ly8iot _177m1a5r",
    flyoutOpenFullHeightSidebar: "_hjoifnf5 _vgub1ku9 _s2eg1p9u",
    flyoutAnimateClosedFullHeightSidebar: "_dm25glyw _hjoifnf5 _vgub1mm8 _hh1u1p9u",
    flexContainer: "_4t3i1osq _1e0c1txw _2lx21bp4 _1bah1yb4",
    hiddenMobileAndDesktop: "_1e0cglyw",
    hiddenMobileOnly: "_1e0cglyw _dm2518uv",
    hiddenDesktopOnly: "_dm25glyw",
    animationBaseStyles: "_10t88iot _1vrh1a5r _xrrpfnf5",
    expandAnimationMobile: "_1xq51ku9 _1nu51p9u",
    collapseAnimationMobile: "_1lh81gzg _1xq51mm8 _aadi1p9u",
    expandAnimationDesktop: "_1sg8k0mc _vgub1ku9 _s2eg1p9u",
    collapseAnimationDesktop: "_1sg81gzg _vgub1mm8 _hh1u1p9u"
};
const $897ab7f8a2e9a596$var$fallbackDefaultWidth = 320;
const $897ab7f8a2e9a596$export$c735dc1c21910e21 = 500; /**
                                        * We need an additional component layer so we can wrap the side nav in a `OpenLayerObserver` and have access to the
                                        * context value.
                                        */ 
function $897ab7f8a2e9a596$var$SideNavInternal({ children: children, defaultCollapsed: defaultCollapsed, defaultWidth: defaultWidthProp = $897ab7f8a2e9a596$var$fallbackDefaultWidth, testId: testId, label: label = 'Sidebar', skipLinkLabel: skipLinkLabel = label, onExpand: onExpand, onCollapse: onCollapse, onPeekStart: onPeekStart, onPeekEnd: onPeekEnd, id: providedId, canToggleWithShortcut: canToggleWithShortcut }) {
    const isFhsEnabled = (0, $8zs3p.useIsFhsEnabled)();
    const id = (0, $d4FF7.useLayoutId)({
        providedId: providedId
    });
    const expandAndFocusSideNav = (0, $1cuAd.useExpandSideNav)({
        trigger: 'skip-link'
    }); /**
       * Called after clicking on the side nav skip link, and ensures the side nav is expanded so that it is focusable.
       *
       * We need to update the DOM synchronously because `.focus()` is called synchronously after this state update.
       *
       * Only used when `platform_dst_nav4_skip_link_a11y_1` is OFF; can be removed on gate cleanup.
       */ 
    const synchronouslyExpandSideNav = (0, $42omo.useCallback)(()=>{
        (0, $jTxSS.flushSync)(()=>{
            /**
       * Calling this unconditionally and relying on it to avoid no-op renders.
       *
       * We _could_ call it conditionally, but we'd be duplicating the screen size checks `expandAndFocusSideNav` makes.
       */ expandAndFocusSideNav();
        });
    }, [
        expandAndFocusSideNav
    ]);
    (0, $3RzOP.useSkipLinkInternal)({
        id: id,
        label: skipLinkLabel,
        /**
     * `navigate` is the gate-on contract: it owns expanding the side nav AND moving
     * focus to the first nav item, atomically (via `useExpandSideNav`'s `flushSync`).
     *
     * `onBeforeNavigate` is the legacy contract used only when the gate is OFF.
     * On gate cleanup, drop `onBeforeNavigate` and `synchronouslyExpandSideNav` here.
     */ navigate: (0, $dh538.fg)('platform_dst_nav4_skip_link_a11y_1') ? expandAndFocusSideNav : undefined,
        onBeforeNavigate: (0, $dh538.fg)('platform_dst_nav4_skip_link_a11y_1') ? undefined : synchronouslyExpandSideNav
    });
    const sideNavState = (0, $42omo.useContext)((0, $hEvVF.SideNavVisibilityState));
    const setSideNavState = (0, $42omo.useContext)((0, $1w9Ty.SetSideNavVisibilityState));
    const { isExpandedOnDesktop: isExpandedOnDesktop, isExpandedOnMobile: isExpandedOnMobile } = (0, $7R2w7.useSideNavVisibility)({
        defaultCollapsed: defaultCollapsed
    }); // We are placing `defaultCollapsed` into a state container so we can have a stable reference to the initial value.
    // This is so we can use it in an effect _that only runs once_, after the initial render on the client,
    // to sync the side nav context (provided in `<Root>`) with the `defaultCollapsed` prop provided to `<SideNav>`.
    const [initialDefaultCollapsed] = (0, $42omo.useState)(defaultCollapsed);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [initialIsExpandedOnDesktop] = (0, $42omo.useState)(isExpandedOnDesktop); /**
                                                                       * Captures the initial collapsed/expanded state of the side nav.
                                                                       *
                                                                       * Only firing on desktop because the nav is never open by default on mobile.
                                                                       */ 
    (0, $42omo.useEffect)(()=>{
        if (initialIsExpandedOnDesktop) {
            const isDesktop = window.matchMedia('(min-width: 64rem)').matches;
            if (isDesktop) {
                const navigationAnalyticsEvent = createAnalyticsEvent({
                    source: 'topNav',
                    actionSubject: 'sideNav',
                    action: 'viewedOnLoad',
                    actionSubjectId: 'sideNavMenu',
                    attributes: {
                        screen: 'desktop'
                    }
                });
                navigationAnalyticsEvent.fire('navigation');
            }
        }
    }, [
        createAnalyticsEvent,
        initialIsExpandedOnDesktop
    ]);
    const defaultWidth = (0, $5KskV.useSafeDefaultWidth)({
        defaultWidthProp: defaultWidthProp,
        fallbackDefaultWidth: $897ab7f8a2e9a596$var$fallbackDefaultWidth,
        slotName: 'SideNav'
    });
    const [width, setWidth] = (0, $42omo.useState)(defaultWidth);
    const clampedWidth = `clamp(${$897ab7f8a2e9a596$var$widthResizeBounds.min}, ${width}px, ${$897ab7f8a2e9a596$var$widthResizeBounds.max})`;
    const dangerouslyHoistSlotSizes = (0, $42omo.useContext)((0, $8jREP.DangerouslyHoistSlotSizes));
    const navRef = (0, $42omo.useRef)(null);
    const panelSplitterPortalTargetRef = (0, $42omo.useRef)(null); /**
                                                                             * Used to share the side nav element with the `Panel`,
                                                                             * which observes the side nav to determine its maximum width.
                                                                             */ 
    const sharedRef = (0, $ijWqx.useSideNavRef)();
    const mergedRef = (0, $3654r.default)([
        navRef,
        sharedRef
    ]);
    const toggleButtonElement = (0, $42omo.useContext)((0, $8SLJH.SideNavToggleButtonElement));
    const topNavStartElement = (0, $42omo.useContext)((0, $5o2qn.TopNavStartElement));
    const devTimeOnlyAttributes = {};
    const openLayerObserver = (0, $6UUmP.useOpenLayerObserver)();
    const flyoutStateRef = (0, $42omo.useRef)({
        type: 'not-active'
    });
    const isFlyoutVisible = sideNavState?.flyout === 'open';
    const isExpandedOnDesktopRef = (0, $g6aM3.default)(isExpandedOnDesktop);
    const hasPeekStartedRef = (0, $42omo.useRef)(false);
    const onPeekStartRef = (0, $g6aM3.default)(onPeekStart);
    const onPeekEndRef = (0, $g6aM3.default)(onPeekEnd);
    const onPeekStartTimeoutIdRef = (0, $42omo.useRef)(undefined);
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            clearTimeout(onPeekStartTimeoutIdRef.current);
        };
    }, []);
    const updateFlyoutState = (0, $42omo.useMemo)(()=>{
        function tryAbortPendingClose() {
            if (flyoutStateRef.current.type === 'waiting-for-close') flyoutStateRef.current.abort();
        }
        function open() {
            // Prevent the flyout from being opened if there are any open layers in the top nav start
            if (openLayerObserver && openLayerObserver.getCount({
                namespace: (0, $K0HEo.openLayerObserverTopNavStartNamespace),
                type: 'popup'
            }) > 0) return;
            const prevFlyoutState = flyoutStateRef.current;
            tryAbortPendingClose();
            flyoutStateRef.current = {
                type: 'open'
            };
            setSideNavState((currentState)=>{
                if (currentState?.desktop === 'collapsed' && currentState?.flyout !== 'open') return {
                    ...currentState,
                    flyout: 'open'
                };
                return currentState;
            }); // Avoid redundant calls to `onPeekStart()`
            if (prevFlyoutState.type === 'not-active') {
                clearTimeout(onPeekStartTimeoutIdRef.current);
                onPeekStartTimeoutIdRef.current = setTimeout(()=>{
                    // If the flyout isn't still open after ~500ms then we won't count the peek
                    // As we want to track user intention rather than all hovers
                    if (isExpandedOnDesktopRef.current || flyoutStateRef.current.type !== 'open') return;
                    hasPeekStartedRef.current = true;
                    onPeekStartRef.current?.();
                }, $897ab7f8a2e9a596$export$c735dc1c21910e21);
            }
        }
        function close() {
            const prevFlyoutState_0 = flyoutStateRef.current;
            tryAbortPendingClose();
            flyoutStateRef.current = {
                type: 'not-active'
            };
            setSideNavState((currentState_0)=>{
                if (currentState_0?.desktop === 'collapsed' && currentState_0?.flyout === 'open') return {
                    ...currentState_0,
                    flyout: 'triggered-animate-close'
                };
                return currentState_0;
            }); // Avoid redundant calls to `onPeekEnd()`
            if (prevFlyoutState_0.type !== 'not-active' && hasPeekStartedRef.current) {
                hasPeekStartedRef.current = false;
                onPeekEndRef.current?.({
                    trigger: isExpandedOnDesktopRef.current ? 'side-nav-expand' : 'mouse-leave'
                });
            }
        }
        return function onAction(action) {
            if (action === 'drag-from-flyout-started') {
                open();
                flyoutStateRef.current = {
                    type: 'is-dragging-from-flyout'
                };
                return;
            }
            if (action === 'drag-from-flyout-finished') {
                open();
                return;
            } // ignoring all actions until the drag is finished
            if (flyoutStateRef.current.type === 'is-dragging-from-flyout') return;
            if (action === 'open') {
                open();
                return;
            }
            if (action === 'waiting-for-close') {
                if (flyoutStateRef.current.type === 'waiting-for-close') return;
                 // A timeout is used to close the flyout after a delay when the user mouses out of the flyout area, and to allow
                // us to cancel the close if the user mouses back in.
                const timeout = setTimeout(()=>{
                    updateFlyoutState('ready-to-close');
                }, (0, $b9b280e8233788f4$export$a7801e29f563faad));
                flyoutStateRef.current = {
                    type: 'waiting-for-close',
                    abort () {
                        clearTimeout(timeout);
                    }
                };
                return;
            }
            if (action === 'ready-to-close') {
                // If there are no open layers, we can close the flyout.
                if (openLayerObserver?.getCount({
                    namespace: (0, $K0HEo.openLayerObserverSideNavNamespace)
                }) === 0) {
                    close();
                    return;
                }
                flyoutStateRef.current = {
                    type: 'ready-to-close'
                };
                return;
            }
            if (action === 'force-close') {
                close();
                return;
            }
        };
    }, [
        isExpandedOnDesktopRef,
        onPeekEndRef,
        onPeekStartRef,
        openLayerObserver,
        setSideNavState
    ]);
    const toggleVisibilityByScreenResize = (0, $622t3.useToggleSideNav)({
        trigger: 'screen-resize'
    });
    const toggleVisibilityByClickOutsideOnMobile = (0, $622t3.useToggleSideNav)({
        trigger: 'click-outside-on-mobile'
    }); // Using `useLayoutEffect` so that there's no visual shift in non-SSR environments when using legacy API
    // For SSR the new API is still necessary
    (0, $42omo.useLayoutEffect)(()=>{
        if (sideNavState !== null) // Only need to do an initial sync if it hasn't been initialized from Root
        return;
         // Sync the visibility in context (provided in `<Root>`) with the local `defaultCollapsed` prop provided to `SideNav`
        // after SSR hydration. This should only run once, after the initial render on the client.
        (0, $42omo.startTransition)(()=>{
            setSideNavState({
                desktop: initialDefaultCollapsed ? 'collapsed' : 'expanded',
                mobile: 'collapsed',
                flyout: 'closed',
                lastTrigger: null
            });
        });
    }, [
        initialDefaultCollapsed,
        setSideNavState,
        sideNavState
    ]);
    const handleExpand = (0, $42omo.useCallback)(({ screen: screen, trigger: trigger })=>{
        onExpand?.({
            screen: screen,
            trigger: trigger
        });
        const navigationAnalyticsEvent_0 = createAnalyticsEvent({
            source: 'topNav',
            actionSubject: 'sideNav',
            action: 'expanded',
            actionSubjectId: 'sideNavMenu',
            attributes: {
                trigger: trigger
            }
        });
        navigationAnalyticsEvent_0.fire('navigation'); // When the side nav gets expanded, we close the flyout to reset it.
        // This prevents the flyout from staying open and ensures we are respecting the user's intent to expand.
        updateFlyoutState('force-close');
    }, [
        onExpand,
        updateFlyoutState,
        createAnalyticsEvent
    ]);
    const handleCollapse = (0, $42omo.useCallback)(({ screen: screen_0, trigger: trigger_0 })=>{
        onCollapse?.({
            screen: screen_0,
            trigger: trigger_0
        });
        const navigationAnalyticsEvent_1 = createAnalyticsEvent({
            source: 'topNav',
            actionSubject: 'sideNav',
            action: 'collapsed',
            actionSubjectId: 'sideNavMenu',
            attributes: {
                trigger: trigger_0
            }
        });
        navigationAnalyticsEvent_1.fire('navigation'); // When the side nav gets collapsed, we close the flyout to reset it.
        // This prevents the flyout from staying open and ensures we are respecting the user's intent to collapse.
        updateFlyoutState('force-close');
    }, [
        onCollapse,
        updateFlyoutState,
        createAnalyticsEvent
    ]);
    (0, $f521bee41562bd5b$export$1904b8f2577aba9a)({
        onExpand: handleExpand,
        onCollapse: handleCollapse,
        isExpandedOnDesktop: isExpandedOnDesktop,
        isExpandedOnMobile: isExpandedOnMobile,
        lastTrigger: sideNavState?.lastTrigger ?? null
    });
    (0, $42omo.useEffect)(()=>{
        const mediaQueryList = window.matchMedia('(min-width: 64rem)');
        return (0, $fFa3V.bind)(mediaQueryList, {
            type: 'change',
            listener () {
                if (mediaQueryList.matches) // We're transitioning from tablet to desktop viewport size.
                // We forcibly show the side nav if it was shown on mobile.
                {
                    if (isExpandedOnMobile && !isExpandedOnDesktop) toggleVisibilityByScreenResize();
                }
            }
        });
    }, [
        toggleVisibilityByScreenResize,
        isExpandedOnDesktop,
        isExpandedOnMobile
    ]); /**
                                                                                  * Close the mobile side nav if there is a click outside.
                                                                                  *
                                                                                  * Binding/unbinding on changes to `isExpandedOnMobile` instead of window size changes for simplicity.
                                                                                  * If we listened to window size changes we'd need nested `bind()` calls.
                                                                                  */ 
    (0, $42omo.useEffect)(()=>{
        if (!isExpandedOnMobile) return;
         /**
       * The expected URL fragment used by the side nav skip link.
       */ 
        const skipLinkUrlFragment = `#${id}`;
        return (0, $fFa3V.bind)(window, {
            type: 'click',
            listener (event) {
                if (window.matchMedia('(min-width: 64rem)').matches) // Clicks on desktop should do nothing
                return;
                const sideNav = navRef.current;
                if (!sideNav || !(event.target instanceof Node)) // Ignore if our element references are invalid
                return;
                if (!event.target.isConnected) /**
           * If the element that was clicked is no longer in the document, we should not collapse the side nav.
           * This can happen when the user clicks on a dropdown menu item (such as one used in a `...` More menu),
           * as the dropdown menu will close after being clicked. By the time this event listener runs, the clicked
           * element will no longer be in the document, so the check below for `sideNav.contains(event.target)` will fail.
           */ return;
                if (sideNav.contains(event.target)) // Clicks inside the side nav should not close it
                return;
                if (toggleButtonElement?.contains(event.target)) // Clicks on the toggle button will already toggle the side nav,
                // so we need to ignore it or we end up doing a double toggle
                return;
                if (event.target instanceof HTMLAnchorElement && /**
         * Intentionally using `.getAttribute()` for simplicity to match exactly what we expect
         * for skip links.
         *
         * Alternatives considered:
         *
         * - Using `.href` returns a full URL, which would then require extra parsing.
         * - Using `.hash` could incorrectly capture `<a href="/another-page#skip-link-id>` so we'd need extra checks.
         *
         * This approach has an edge case of `<a href="/same-page#skip-link-id>` not being captured,
         * but we are okay with that trade-off.
         */ event.target.getAttribute('href') === skipLinkUrlFragment) // This was a click on a link to the side nav, so we shouldn't try to collapse the SideNav.
                // It was most likely the skip link, although anyone can render a link with the ID.
                // In either case keeping the SideNav expanded makes sense.
                return;
                toggleVisibilityByClickOutsideOnMobile();
            }
        });
    }, [
        id,
        isExpandedOnMobile,
        toggleButtonElement,
        toggleVisibilityByClickOutsideOnMobile
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!toggleButtonElement) return;
        return (0, $fFa3V.bind)(toggleButtonElement, {
            type: 'mouseenter',
            listener () {
                // Only flyout the side nav if the user hovered while the side nav was collapsed
                if (isExpandedOnDesktop) return;
                 // Only flyout the side nav on desktop viewports
                const { matches: matches } = window.matchMedia('(min-width: 64rem)');
                if (matches) updateFlyoutState('open');
            }
        });
    }, [
        updateFlyoutState,
        toggleButtonElement,
        isExpandedOnDesktop
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!toggleButtonElement) return;
        return (0, $fFa3V.bind)(toggleButtonElement, {
            type: 'mouseleave',
            listener () {
                // If the side nav is not in flyout mode, we don't need to do anything
                if (!isFlyoutVisible) return;
                updateFlyoutState('waiting-for-close');
            }
        });
    }, [
        isFlyoutVisible,
        toggleButtonElement,
        updateFlyoutState
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!navRef.current) return;
        return (0, $fFa3V.bind)(navRef.current, {
            type: 'mouseenter',
            listener () {
                // If the side nav is not in flyout mode, we don't need to do anything
                if (isExpandedOnDesktop || !isFlyoutVisible) return;
                 // The user mouses has moused back over the side nav
                updateFlyoutState('open');
            }
        });
    }, [
        isFlyoutVisible,
        updateFlyoutState,
        isExpandedOnDesktop
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!navRef.current) return;
        return (0, $fFa3V.bind)(navRef.current, {
            type: 'mouseleave',
            listener () {
                // If the side nav is not in flyout mode, we don't need to do anything
                if (!isFlyoutVisible) return;
                updateFlyoutState('waiting-for-close');
            }
        });
    }, [
        isFlyoutVisible,
        updateFlyoutState
    ]);
    (0, $42omo.useEffect)(()=>{
        const nav = navRef.current;
        if (!nav) return;
        if (!isFlyoutVisible) return;
         // Using a monitor rather than a drop target. Rationale:
        // - We are not creating a drop target for the users to drop on,
        //   we are just interested in listening to events within an element
        // - We do not want to impact `location.{*}.dropTargets` in events
        return (0, $4T4vf.monitorForElements)({
            canMonitor ({ source: source }) {
                return nav.contains(source.element);
            },
            onGenerateDragPreview () {
                updateFlyoutState('drag-from-flyout-started');
            },
            onDrop ({ location: location }) {
                // Always marking the drag and done
                updateFlyoutState('drag-from-flyout-finished'); // If the user dropped outside of the flyout, we will close the flyout
                const underUsersPointer = document.elementFromPoint(location.current.input.clientX, location.current.input.clientY);
                if (!nav.contains(underUsersPointer)) updateFlyoutState('waiting-for-close');
            }
        });
    }, [
        isFlyoutVisible,
        updateFlyoutState
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!topNavStartElement || !toggleButtonElement) return;
        return (0, $fFa3V.bind)(topNavStartElement, {
            type: 'mouseover',
            listener (event_0) {
                // If the side nav is not in flyout mode, we don't need to do anything
                if (isExpandedOnDesktop || !isFlyoutVisible) return;
                if (event_0.target === topNavStartElement) {
                    // The mouse is directly over the TopNavStart element, so cancel any pending flyout closes.
                    updateFlyoutState('open');
                    return;
                }
                if (event_0.target instanceof Element && toggleButtonElement.contains(event_0.target)) // The mouse is over the toggle button or any of its children, so we don't want to close the flyout.
                // We also don't need to cancel any pending closes, as we have separate event listeners for the toggle button mouse events.
                return;
                 // The user has moused over a child element of the TopNavStart element that isn't the toggle button, e.g. the app switcher or nav logo,
                // so we should close the flyout (with a delay).
                updateFlyoutState('waiting-for-close');
            }
        });
    }, [
        topNavStartElement,
        isFlyoutVisible,
        toggleButtonElement,
        isExpandedOnDesktop,
        updateFlyoutState
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!topNavStartElement) return;
        return (0, $fFa3V.bind)(topNavStartElement, {
            type: 'mouseleave',
            listener () {
                // If the side nav is not in flyout mode, we don't need to do anything
                if (!isFlyoutVisible) return;
                 // The mouse has left the TopNavStart element, so we should close the flyout with a delay.
                updateFlyoutState('waiting-for-close');
            }
        });
    }, [
        topNavStartElement,
        isFlyoutVisible,
        updateFlyoutState
    ]);
    (0, $42omo.useEffect)(()=>{
        // Close the flyout if there are no more layers open and the user is not mousing over the
        // flyout areas (side nav, TopNavStart element)
        return openLayerObserver?.onChange(({ count: count })=>{
            if (flyoutStateRef.current.type === 'ready-to-close' && count === 0) updateFlyoutState('force-close');
        }, {
            namespace: (0, $K0HEo.openLayerObserverSideNavNamespace)
        });
    }, [
        openLayerObserver,
        updateFlyoutState
    ]);
    (0, $42omo.useEffect)(()=>{
        // Clear flyout close timer if being unmounted
        return function cleanupPendingFlyoutClose() {
            if (flyoutStateRef.current.type === 'waiting-for-close') flyoutStateRef.current.abort();
        };
    }, []);
    (0, $51a0d9035b4b4171$export$f762e7ac9d86adb0)({
        canToggleWithShortcut: canToggleWithShortcut
    }); // Used to conditionally display the keyboard shortcut in the SideNavPanelSplitter tooltip.
    const isShortcutEnabled = (0, $iCTy4.useIsSideNavShortcutEnabled)();
    (0, $38bxn.useResizingWidthCssVarOnRootElement)({
        isEnabled: true,
        cssVar: $897ab7f8a2e9a596$var$panelSplitterResizingVar,
        panelId: (0, $K0HEo.sideNavPanelSplitterId)
    });
    const isExpandedStateDifferentFromInitial = isExpandedOnMobile || isExpandedOnDesktop !== initialIsExpandedOnDesktop; /**
                                                                                                                         * Used to track (between renders) if the expanded state of the side nav has ever changed since mount.
                                                                                                                         *
                                                                                                                         * Cannot rely solely on `isExpandedStateDifferentFromInitial` because the expanded state can go back to the initial state.
                                                                                                                         */ 
    const hasExpandedStateChangedRef = (0, $42omo.useRef)(false);
    (0, $42omo.useEffect)(()=>{
        if (hasExpandedStateChangedRef.current) return;
        if (isExpandedStateDifferentFromInitial) hasExpandedStateChangedRef.current = true;
    }, [
        isExpandedStateDifferentFromInitial
    ]); /**
                                              * If the expanded state of the side nav has ever changed since mount.
                                              *
                                              * Used to prevent sidebar expand animations from running on the initial load.
                                              * Otherwise, the `@starting-style` rule will cause the sidebar to slide in initially.
                                              */ 
    const hasExpandedStateChanged = isExpandedStateDifferentFromInitial || hasExpandedStateChangedRef.current; // This is only used for the regular expand and collapse animations, not the flyout animations.
    const shouldShowSidebarToggleAnimation = isFhsEnabled && // We do not apply the animation styles on the initial render, as the `@starting-style` rule will cause the sidebar to
    // slide in initially.
    hasExpandedStateChanged && // We also do not apply the animation styles if the side nav is in flyout mode to make sure we don't override flyout styles.
    // If we instead try to unset the `transform` property in the flyout styles using `transform: initial`, it results in the entire
    // flyout animation being disabled.
    !isFlyoutVisible && /**
   * Disabling animations for Firefox, as it doesn't support animating the `display` property:
   * https://caniuse.com/mdn-css_properties_display_is_transitionable
   *
   * As of October 2025, Firefox supports the expand animation, but not the collapse animation (it instantly changes to `display: none`).
   * Because of this, we are disabling all sidebar animations for Firefox so it doesn't look like a bug.
   *
   * Unfortunately we cannot use `@supports` to target the support of `transition-behavior: allow-discrete` specifically
   * for the `display` property. And `@supports at-rule(@starting-style)` is also not ready for browser use yet.
   *
   * We are using JS to detect Firefox and disable animations, instead of using CSS, as Compiled currently does not merge duplicate
   * CSS at-rules when at-rules are nested: https://github.com/atlassian-labs/compiled/blob/e04a325915e1d13010205089e4915de0e53bc2d4/packages/css/src/plugins/merge-duplicate-at-rules.ts#L5
   * Avoiding nesting the `@supports` at-rule inside of `@media` means Compiled can remove duplicate styles from the generated CSS.
   */ !$897ab7f8a2e9a596$var$isFirefox;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("nav", {
        id: id,
        ...devTimeOnlyAttributes,
        "data-layout-slot": true,
        "aria-label": label,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/enforce-style-prop
            [(0, $K0HEo.sideNavVar)]: clampedWidth
        },
        ref: mergedRef,
        "data-testid": testId,
        className: (0, $gMc0m.default)([
            $897ab7f8a2e9a596$var$styles.root,
            isExpandedOnDesktop && !isExpandedOnMobile && !isFlyoutVisible && $897ab7f8a2e9a596$var$styles.hiddenMobileOnly,
            !isExpandedOnDesktop && isExpandedOnMobile && !isFlyoutVisible && $897ab7f8a2e9a596$var$styles.hiddenDesktopOnly,
            !isExpandedOnDesktop && !isExpandedOnMobile && !isFlyoutVisible && $897ab7f8a2e9a596$var$styles.hiddenMobileAndDesktop,
            isFhsEnabled && $897ab7f8a2e9a596$var$styles.animationRTLSupport,
            shouldShowSidebarToggleAnimation && $897ab7f8a2e9a596$var$styles.animationBaseStyles,
            isExpandedOnMobile && shouldShowSidebarToggleAnimation && $897ab7f8a2e9a596$var$styles.expandAnimationMobile,
            !isExpandedOnMobile && shouldShowSidebarToggleAnimation && $897ab7f8a2e9a596$var$styles.collapseAnimationMobile,
            isExpandedOnDesktop && shouldShowSidebarToggleAnimation && $897ab7f8a2e9a596$var$styles.expandAnimationDesktop,
            !isExpandedOnDesktop && shouldShowSidebarToggleAnimation && $897ab7f8a2e9a596$var$styles.collapseAnimationDesktop,
            sideNavState?.flyout === 'open' && !isFhsEnabled && $897ab7f8a2e9a596$var$styles.flyoutOpen,
            sideNavState?.flyout === 'triggered-animate-close' && !isFhsEnabled && $897ab7f8a2e9a596$var$styles.flyoutAnimateClosed,
            (sideNavState?.flyout === 'open' || sideNavState?.flyout === 'triggered-animate-close') && !$897ab7f8a2e9a596$var$isFirefox && isFhsEnabled && $897ab7f8a2e9a596$var$styles.flyoutBaseStylesFullHeightSidebar,
            sideNavState?.flyout === 'triggered-animate-close' && !$897ab7f8a2e9a596$var$isFirefox && isFhsEnabled && $897ab7f8a2e9a596$var$styles.flyoutAnimateClosedFullHeightSidebar,
            sideNavState?.flyout === 'open' && !$897ab7f8a2e9a596$var$isFirefox && isFhsEnabled && $897ab7f8a2e9a596$var$styles.flyoutOpenFullHeightSidebar,
            sideNavState?.flyout === 'triggered-animate-close' && !$897ab7f8a2e9a596$var$isFirefox && isFhsEnabled && $897ab7f8a2e9a596$var$styles.flyoutAnimateClosedFullHeightSidebar
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9w5su.DangerouslyHoistCssVarToDocumentRoot), {
        variableName: (0, $K0HEo.sideNavLiveWidthVar),
        value: "0px",
        mediaQuery: (0, $bWLcG.media).above.md,
        responsiveValue: isExpandedOnDesktop ? `var(${$897ab7f8a2e9a596$var$panelSplitterResizingVar}, ${clampedWidth})` : 0
    }), dangerouslyHoistSlotSizes && // ------ START UNSAFE STYLES ------
    // These styles are only needed for the UNSAFE legacy use case for Jira + Confluence.
    // When they aren't needed anymore we can delete them wholesale.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9w5su.DangerouslyHoistCssVarToDocumentRoot), {
        variableName: (0, $K0HEo.UNSAFE_sideNavLayoutVar),
        value: `var(${(0, $K0HEo.sideNavLiveWidthVar)})`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c9vFp.PanelSplitterProvider), {
        panelId: (0, $K0HEo.sideNavPanelSplitterId),
        panelRef: navRef,
        portalRef: isFhsEnabled ? panelSplitterPortalTargetRef : undefined,
        panelWidth: width,
        onCompleteResize: setWidth,
        getResizeBounds: $897ab7f8a2e9a596$var$getResizeBounds,
        resizingCssVar: $897ab7f8a2e9a596$var$panelSplitterResizingVar,
        isEnabled: !isFlyoutVisible,
        shortcut: isShortcutEnabled ? (0, $huiud.sideNavToggleTooltipKeyboardShortcut) : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            $897ab7f8a2e9a596$var$styles.flexContainer
        ])
    }, children))), isFhsEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        ref: panelSplitterPortalTargetRef,
        "data-layout-slot": true,
        style: {
            // We need to use an inline style here to share the side nav width to position the panel splitter.
            // We can't use the existing --n_sNvlw variable (sideNavLiveWidthVar) because it is set to 0 when the side nav is collapsed on desktop,
            // however the panel splitter is still visible and usable on small viewports until 48rem.
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            [$897ab7f8a2e9a596$var$sideNavClampedWidthVar]: clampedWidth
        },
        className: (0, $gMc0m.default)([
            $897ab7f8a2e9a596$var$panelSplitterPortalTargetStyles.root,
            isExpandedOnDesktop && !isExpandedOnMobile && !isFlyoutVisible && $897ab7f8a2e9a596$var$styles.hiddenMobileOnly,
            !isExpandedOnDesktop && isExpandedOnMobile && !isFlyoutVisible && $897ab7f8a2e9a596$var$styles.hiddenDesktopOnly,
            !isExpandedOnDesktop && !isExpandedOnMobile && !isFlyoutVisible && $897ab7f8a2e9a596$var$styles.hiddenMobileAndDesktop
        ])
    }));
}
const $897ab7f8a2e9a596$export$1a35787d6353cf6a = (0, $4pOgL.isReactCompilerActivePlatform)() ? function SideNav(t0) {
    const $ = (0, $frIzR.c)(13);
    const { children: children, defaultCollapsed: defaultCollapsed, defaultWidth: t1, testId: testId, label: label, skipLinkLabel: t2, onExpand: onExpand, onCollapse: onCollapse, onPeekStart: onPeekStart, onPeekEnd: onPeekEnd, canToggleWithShortcut: canToggleWithShortcut, id: id } = t0;
    const defaultWidth = t1 === undefined ? 320 : t1;
    const skipLinkLabel = t2 === undefined ? label : t2;
    let t3;
    if ($[0] !== canToggleWithShortcut || $[1] !== children || $[2] !== defaultCollapsed || $[3] !== defaultWidth || $[4] !== id || $[5] !== label || $[6] !== onCollapse || $[7] !== onExpand || $[8] !== onPeekEnd || $[9] !== onPeekStart || $[10] !== skipLinkLabel || $[11] !== testId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fQcKS.OpenLayerObserverNamespaceProvider), {
            namespace: (0, $K0HEo.openLayerObserverSideNavNamespace)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($897ab7f8a2e9a596$var$SideNavInternal, {
            defaultCollapsed: defaultCollapsed,
            defaultWidth: defaultWidth,
            testId: testId,
            label: label,
            skipLinkLabel: skipLinkLabel,
            onExpand: onExpand,
            onCollapse: onCollapse,
            onPeekStart: onPeekStart,
            onPeekEnd: onPeekEnd,
            id: id,
            canToggleWithShortcut: canToggleWithShortcut
        }, children));
        $[0] = canToggleWithShortcut;
        $[1] = children;
        $[2] = defaultCollapsed;
        $[3] = defaultWidth;
        $[4] = id;
        $[5] = label;
        $[6] = onCollapse;
        $[7] = onExpand;
        $[8] = onPeekEnd;
        $[9] = onPeekStart;
        $[10] = skipLinkLabel;
        $[11] = testId;
        $[12] = t3;
    } else t3 = $[12];
    return t3;
} : function SideNav({ children: children, defaultCollapsed: defaultCollapsed, defaultWidth: defaultWidth = 320, testId: testId, label: label, skipLinkLabel: // Default value is defined in `SideNavInternal`
skipLinkLabel = label, onExpand: // Default value is defined in `SideNavInternal`
onExpand, onCollapse: onCollapse, onPeekStart: onPeekStart, onPeekEnd: onPeekEnd, canToggleWithShortcut: canToggleWithShortcut, id: id }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fQcKS.OpenLayerObserverNamespaceProvider), {
        namespace: (0, $K0HEo.openLayerObserverSideNavNamespace)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($897ab7f8a2e9a596$var$SideNavInternal, {
        defaultCollapsed: defaultCollapsed,
        defaultWidth: defaultWidth,
        testId: testId,
        label: label,
        skipLinkLabel: skipLinkLabel,
        onExpand: onExpand,
        onCollapse: onCollapse,
        onPeekStart: onPeekStart,
        onPeekEnd: onPeekEnd,
        id: id,
        canToggleWithShortcut: canToggleWithShortcut
    }, children));
};
module.exports["SideNav"] = $897ab7f8a2e9a596$export$1a35787d6353cf6a;

});

parcelRegister("fQcKS", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $dRnqM = parcelRequire("dRnqM");


var $cGkQr = parcelRequire("cGkQr");


var $4pUFZ = parcelRequire("4pUFZ");

const $b83059ddc27aa2a1$export$327d0d2a7ae6f7cc = (0, $4pOgL.isReactCompilerActivePlatform)() ? function OpenLayerObserverNamespaceProvider(t0) {
    const $ = (0, $frIzR.c)(6);
    const { children: children, namespace: namespace } = t0;
    const parentContext = (0, $4pUFZ.useOpenLayerObserverNamespace)();
    let t1;
    let t2;
    if ($[0] !== parentContext) {
        t1 = ()=>{
            (0, $dRnqM.default)(parentContext === null, `An OpenLayerObserver namespace already exists in this component tree: ${parentContext}. Nesting OpenLayerObserverNamespaceProvider is not supported.`);
        };
        t2 = [
            parentContext
        ];
        $[0] = parentContext;
        $[1] = t1;
        $[2] = t2;
    } else {
        t1 = $[1];
        t2 = $[2];
    }
    (0, $42omo.useEffect)(t1, t2);
    let t3;
    if ($[3] !== children || $[4] !== namespace) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cGkQr.OpenLayerObserverNamespaceContext).Provider, {
            value: namespace
        }, children);
        $[3] = children;
        $[4] = namespace;
        $[5] = t3;
    } else t3 = $[5];
    return t3;
} : function OpenLayerObserverNamespaceProvider({ children: children, namespace: namespace }) {
    // If there is an existing namespace context being provided, throw an invariant.
    // This use case is not supported at this time.
    const parentContext = (0, $4pUFZ.useOpenLayerObserverNamespace)();
    (0, $42omo.useEffect)(()=>{
        (0, $dRnqM.default)(parentContext === null, `An OpenLayerObserver namespace already exists in this component tree: ${parentContext}. Nesting OpenLayerObserverNamespaceProvider is not supported.`);
    }, [
        parentContext
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cGkQr.OpenLayerObserverNamespaceContext).Provider, {
        value: namespace
    }, children);
};
module.exports["OpenLayerObserverNamespaceProvider"] = $b83059ddc27aa2a1$export$327d0d2a7ae6f7cc;

});

parcelRegister("3RzOP", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $dEIJ1 = parcelRequire("dEIJ1");

const $b9ed6a24054a0f06$export$707b94c26b8b75aa = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(10);
    const { id: id, label: label, listIndex: listIndex, onBeforeNavigate: onBeforeNavigate, navigate: navigate, isHidden: isHidden } = t0;
    const { registerSkipLink: registerSkipLink, unregisterSkipLink: unregisterSkipLink } = (0, $42omo.useContext)((0, $dEIJ1.SkipLinksContext));
    let t1;
    let t2;
    if ($[0] !== id || $[1] !== isHidden || $[2] !== label || $[3] !== listIndex || $[4] !== navigate || $[5] !== onBeforeNavigate || $[6] !== registerSkipLink || $[7] !== unregisterSkipLink) {
        t1 = ()=>{
            if (isHidden) return;
            registerSkipLink({
                id: id,
                label: label,
                listIndex: listIndex,
                onBeforeNavigate: onBeforeNavigate,
                navigate: navigate,
                isHidden: isHidden
            });
            return ()=>{
                unregisterSkipLink(id);
            };
        };
        t2 = [
            id,
            isHidden,
            label,
            listIndex,
            onBeforeNavigate,
            navigate,
            registerSkipLink,
            unregisterSkipLink
        ];
        $[0] = id;
        $[1] = isHidden;
        $[2] = label;
        $[3] = listIndex;
        $[4] = navigate;
        $[5] = onBeforeNavigate;
        $[6] = registerSkipLink;
        $[7] = unregisterSkipLink;
        $[8] = t1;
        $[9] = t2;
    } else {
        t1 = $[8];
        t2 = $[9];
    }
    (0, $42omo.useEffect)(t1, t2);
} : ({ id: id, label: label, listIndex: listIndex, onBeforeNavigate: onBeforeNavigate, navigate: navigate, isHidden: isHidden })=>{
    const { registerSkipLink: registerSkipLink, unregisterSkipLink: unregisterSkipLink } = (0, $42omo.useContext)((0, $dEIJ1.SkipLinksContext));
    (0, $42omo.useEffect)(()=>{
        if (isHidden) /**
       * Skip links are hidden for slots with 0 height or width.
       * They should not be registered.
       */ return;
        registerSkipLink({
            id: id,
            label: label,
            listIndex: listIndex,
            onBeforeNavigate: onBeforeNavigate,
            navigate: navigate,
            isHidden: isHidden
        });
        return ()=>{
            unregisterSkipLink(id);
        };
    }, [
        id,
        isHidden,
        label,
        listIndex,
        onBeforeNavigate,
        navigate,
        registerSkipLink,
        unregisterSkipLink
    ]);
};
module.exports["useSkipLinkInternal"] = $b9ed6a24054a0f06$export$707b94c26b8b75aa;

});

parcelRegister("dEIJ1", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $ee7An = parcelRequire("ee7An");

const $120f326e2f61fdb7$export$4c5cc3b14c7678a = /*#__PURE__*/ (0, $42omo.createContext)({
    registerSkipLink: (0, $ee7An.default),
    unregisterSkipLink: (0, $ee7An.default)
});
module.exports["SkipLinksContext"] = $120f326e2f61fdb7$export$4c5cc3b14c7678a;

});

parcelRegister("5o2qn", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $47a27f2843c2326f$export$e9e5087bd319cc8c = /*#__PURE__*/ (0, $42omo.createContext)(null);
module.exports["TopNavStartElement"] = $47a27f2843c2326f$export$e9e5087bd319cc8c;

});

parcelRegister("9w5su", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");

const $818891c833fc9170$var$getCssStringValue = (value)=>typeof value === 'number' ? `${value}px` : value;
const $818891c833fc9170$export$9f45a1325e3cdfb8 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(6);
    const { variableName: variableName, value: value, mediaQuery: mediaQuery, responsiveValue: responsiveValue } = t0;
    let t1;
    if ($[0] !== value) {
        t1 = $818891c833fc9170$var$getCssStringValue(value);
        $[0] = value;
        $[1] = t1;
    } else t1 = $[1];
    let style = `:root { ${variableName}: ${t1} }`;
    if (mediaQuery && responsiveValue) {
        const t2 = style;
        let t3;
        if ($[2] !== responsiveValue) {
            t3 = $818891c833fc9170$var$getCssStringValue(responsiveValue);
            $[2] = responsiveValue;
            $[3] = t3;
        } else t3 = $[3];
        style = t2 + ` ${mediaQuery} { :root { ${variableName}: ${t3} } }`;
    }
    let t2;
    if ($[4] !== style) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("style", null, style);
        $[4] = style;
        $[5] = t2;
    } else t2 = $[5];
    return t2;
} : ({ variableName: variableName, value: value, mediaQuery: mediaQuery, responsiveValue: responsiveValue })=>{
    /**
   * Note don't put multiple variables in multiple lines. eg
   * <style>
   *   {css1}
   *   {css2}
   * </style>
   *
   * React will insert an empty HTML comment in between the text in SSR.
   * This is not a valid tag and will break the page.
   * <style>foo<!-- -->bar</style>
   */ let style = `:root { ${variableName}: ${$818891c833fc9170$var$getCssStringValue(value)} }`;
    if (mediaQuery && responsiveValue) style += ` ${mediaQuery} { :root { ${variableName}: ${$818891c833fc9170$var$getCssStringValue(responsiveValue)} } }`;
    return(// Using a global style is required for SSR, as we can't use React hooks
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("style", null, style));
};
module.exports["DangerouslyHoistCssVarToDocumentRoot"] = $818891c833fc9170$export$9f45a1325e3cdfb8;

});

parcelRegister("8jREP", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $f3ec473aa51c642a$export$66e2c1a0115af861 = /*#__PURE__*/ (0, $42omo.createContext)(false);
module.exports["DangerouslyHoistSlotSizes"] = $f3ec473aa51c642a$export$66e2c1a0115af861;

});

parcelRegister("c9vFp", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $1D5qM = parcelRequire("1D5qM");

const $e2e4277b85ba6dcf$export$f662bfb764348932 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(19);
    const { panelId: panelId, panelWidth: panelWidth, onCompleteResize: onCompleteResize, getResizeBounds: getResizeBounds, resizingCssVar: resizingCssVar, panelRef: panelRef, portalRef: providedPortalRef, position: t1, isEnabled: t2, shortcut: shortcut, children: children } = t0;
    const position = t1 === undefined ? "end" : t1;
    const isEnabled = t2 === undefined ? true : t2;
    const portalRef = (0, $42omo.useRef)(null);
    const t3 = typeof providedPortalRef !== "undefined" ? providedPortalRef : portalRef;
    let t4;
    if ($[0] !== getResizeBounds || $[1] !== isEnabled || $[2] !== onCompleteResize || $[3] !== panelId || $[4] !== panelRef || $[5] !== panelWidth || $[6] !== position || $[7] !== resizingCssVar || $[8] !== shortcut || $[9] !== t3) {
        t4 = {
            panelId: panelId,
            panelWidth: panelWidth,
            onCompleteResize: onCompleteResize,
            getResizeBounds: getResizeBounds,
            resizingCssVar: resizingCssVar,
            position: position,
            panelRef: panelRef,
            isEnabled: isEnabled,
            portalRef: t3,
            shortcut: shortcut
        };
        $[0] = getResizeBounds;
        $[1] = isEnabled;
        $[2] = onCompleteResize;
        $[3] = panelId;
        $[4] = panelRef;
        $[5] = panelWidth;
        $[6] = position;
        $[7] = resizingCssVar;
        $[8] = shortcut;
        $[9] = t3;
        $[10] = t4;
    } else t4 = $[10];
    const context = t4;
    let t5;
    if ($[11] !== children || $[12] !== context) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1D5qM.PanelSplitterContext).Provider, {
            value: context
        }, children);
        $[11] = children;
        $[12] = context;
        $[13] = t5;
    } else t5 = $[13];
    let t6;
    if ($[14] !== providedPortalRef) {
        t6 = typeof providedPortalRef !== "undefined" ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            ref: portalRef
        });
        $[14] = providedPortalRef;
        $[15] = t6;
    } else t6 = $[15];
    let t7;
    if ($[16] !== t5 || $[17] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, t5, t6);
        $[16] = t5;
        $[17] = t6;
        $[18] = t7;
    } else t7 = $[18];
    return t7;
} : ({ panelId: panelId, panelWidth: panelWidth, onCompleteResize: onCompleteResize, getResizeBounds: getResizeBounds, resizingCssVar: resizingCssVar, panelRef: panelRef, portalRef: providedPortalRef, position: position = 'end', isEnabled: isEnabled = true, shortcut: shortcut, children: children })=>{
    const portalRef = (0, $42omo.useRef)(null);
    const context = (0, $42omo.useMemo)(()=>({
            panelId: panelId,
            panelWidth: panelWidth,
            onCompleteResize: onCompleteResize,
            getResizeBounds: getResizeBounds,
            resizingCssVar: resizingCssVar,
            position: position,
            panelRef: panelRef,
            isEnabled: isEnabled,
            portalRef: typeof providedPortalRef !== 'undefined' ? providedPortalRef : portalRef,
            shortcut: shortcut
        }), [
        panelId,
        panelWidth,
        onCompleteResize,
        getResizeBounds,
        resizingCssVar,
        position,
        panelRef,
        isEnabled,
        providedPortalRef,
        shortcut
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1D5qM.PanelSplitterContext).Provider, {
        value: context
    }, children), typeof providedPortalRef !== 'undefined' ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        ref: portalRef
    }));
};
module.exports["PanelSplitterProvider"] = $e2e4277b85ba6dcf$export$f662bfb764348932;

});

parcelRegister("d4FF7", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");





var $c0qxy = parcelRequire("c0qxy");

const $7390e8978ba097eb$export$fa3cfac0c8e29c5c = (0, $4pOgL.isReactCompilerActivePlatform)() ? function useSkipLinkId() {
    const uniqueId = (0, $c0qxy.useId)();
    return uniqueId;
} : function useSkipLinkId() {
    const uniqueId = (0, $c0qxy.useId)();
    return uniqueId;
};


const $45e765a9556439ab$export$110c3550c7c1c9aa = (0, $4pOgL.isReactCompilerActivePlatform)() ? function useLayoutId(t0) {
    const $ = (0, $frIzR.c)(2);
    let t1;
    if ($[0] !== t0) {
        t1 = t0 === undefined ? {} : t0;
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const { providedId: providedId } = t1;
    const uniqueId = (0, $7390e8978ba097eb$export$fa3cfac0c8e29c5c)();
    const id = providedId ? providedId : uniqueId;
    return id;
} : function useLayoutId({ providedId: providedId } = {}) {
    const uniqueId = (0, $7390e8978ba097eb$export$fa3cfac0c8e29c5c)();
    const id = providedId ? providedId : uniqueId;
    return id;
};
module.exports["useLayoutId"] = $45e765a9556439ab$export$110c3550c7c1c9aa;

});

parcelRegister("38bxn", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $bSjaC = parcelRequire("bSjaC");


var $4T4vf = parcelRequire("4T4vf");


var $5By30 = parcelRequire("5By30");

const $7a27995d8faedf9c$export$d4931ecf0fbcc8fc = (0, $4pOgL.isReactCompilerActivePlatform)() ? function useResizingWidthCssVarOnRootElement(t0) {
    const $ = (0, $frIzR.c)(9);
    const { isEnabled: t1, cssVar: cssVar, panelId: panelId } = t0;
    const isEnabled = t1 === undefined ? true : t1;
    let t2;
    let t3;
    if ($[0] !== cssVar || $[1] !== isEnabled || $[2] !== panelId) {
        t2 = ()=>{
            if (!isEnabled) return;
            return (0, $bSjaC.combine)((0, $4T4vf.monitorForElements)({
                canMonitor (t4) {
                    const { source: source } = t4;
                    return source.data.panelId === panelId;
                },
                onDrag (t5) {
                    const { source: source_0 } = t5;
                    if (!(0, $5By30.isPanelSplitterDragData)(source_0.data)) return;
                    document.documentElement.style.setProperty(cssVar, source_0.data.resizingWidth);
                },
                onDrop () {
                    document.documentElement.style.removeProperty(cssVar);
                }
            }));
        };
        t3 = [
            cssVar,
            isEnabled,
            panelId
        ];
        $[0] = cssVar;
        $[1] = isEnabled;
        $[2] = panelId;
        $[3] = t2;
        $[4] = t3;
    } else {
        t2 = $[3];
        t3 = $[4];
    }
    (0, $42omo.useEffect)(t2, t3);
    let t4;
    let t5;
    if ($[5] !== cssVar || $[6] !== isEnabled) {
        t4 = ()=>{
            if (!isEnabled) return;
            return function cleanupGlobalResizingCssVar() {
                document.documentElement.style.removeProperty(cssVar);
            };
        };
        t5 = [
            cssVar,
            isEnabled
        ];
        $[5] = cssVar;
        $[6] = isEnabled;
        $[7] = t4;
        $[8] = t5;
    } else {
        t4 = $[7];
        t5 = $[8];
    }
    (0, $42omo.useEffect)(t4, t5);
} : function useResizingWidthCssVarOnRootElement({ isEnabled: isEnabled = true, cssVar: cssVar, panelId: panelId }) {
    (0, $42omo.useEffect)(()=>{
        if (!isEnabled) return;
        return (0, $bSjaC.combine)((0, $4T4vf.monitorForElements)({
            canMonitor ({ source: source }) {
                return source.data.panelId === panelId;
            },
            onDrag ({ source: source_0 }) {
                if (!(0, $5By30.isPanelSplitterDragData)(source_0.data)) return;
                /**
         * Copies the resizing width value to the `<html>` element.
         *
         * Required to reflect the live width of the side navigation.
         *
         * Used by:
         *   - Legacy `--leftSidebarWidth` variable
         *   - Panel slot max-width constraint
         *
         * When the legacy `--leftSidebarWidth` variable is no longer needed,
         * we could consider writing to the `Panel` element instead.
         */ document.documentElement.style.setProperty(cssVar, source_0.data.resizingWidth);
            },
            onDrop () {
                document.documentElement.style.removeProperty(cssVar);
            }
        }));
    }, [
        cssVar,
        isEnabled,
        panelId
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!isEnabled) return;
        /**
     * Ensures that the resizing CSS var on the `<html>` element is cleaned up properly
     * if the component unmounts during a drag.
     */ return function cleanupGlobalResizingCssVar() {
            document.documentElement.style.removeProperty(cssVar);
        };
    }, [
        cssVar,
        isEnabled
    ]);
};
module.exports["useResizingWidthCssVarOnRootElement"] = $7a27995d8faedf9c$export$d4931ecf0fbcc8fc;

});

parcelRegister("5KskV", function(module, exports) {
/**
 * Returns the `fallbackWidth` if the provided `defaultWidthProp` is not an integer value.
 */ function $29566d8fd4e4d3b8$export$cff429d7d83ba1f0({ defaultWidthProp: defaultWidthProp, fallbackDefaultWidth: fallbackDefaultWidth, slotName: slotName }) {
    // If the provided `defaultWidth` is invalid then we use our fallback.
    // We are using a runtime check because some invalid numbers like `NaN` are not caught by types,
    // and we saw some issues in products where our experience broke due to this.
    if (!Number.isInteger(defaultWidthProp)) return fallbackDefaultWidth;
    return defaultWidthProp;
}
module.exports["useSafeDefaultWidth"] = $29566d8fd4e4d3b8$export$cff429d7d83ba1f0;

});

parcelRegister("1w9Ty", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $ee7An = parcelRequire("ee7An");

const $8691de4e97db2f96$export$f6b496b07d1ea493 = /*#__PURE__*/ (0, $42omo.createContext)((0, $ee7An.default));
module.exports["SetSideNavVisibilityState"] = $8691de4e97db2f96$export$f6b496b07d1ea493;

});

parcelRegister("8SLJH", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $e79ff5ccaf9d1629$export$9c1768094bef896 = /*#__PURE__*/ (0, $42omo.createContext)(null);
module.exports["SideNavToggleButtonElement"] = $e79ff5ccaf9d1629$export$9c1768094bef896;

});

parcelRegister("hEvVF", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $78abb70ded7cdf66$export$eb04201bb6dd1e4e = /*#__PURE__*/ (0, $42omo.createContext)(null);
module.exports["SideNavVisibilityState"] = $78abb70ded7cdf66$export$eb04201bb6dd1e4e;

});

parcelRegister("ijWqx", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $42omo = parcelRequire("42omo");


var $kF45k = parcelRequire("kF45k");

const $a4e20473d9b39975$export$fa4d0cff03b1ea4f = (0, $4pOgL.isReactCompilerActivePlatform)() ? function useSideNavRef() {
    return (0, $42omo.useContext)((0, $kF45k.SideNavRefContext));
} : function useSideNavRef() {
    return (0, $42omo.useContext)((0, $kF45k.SideNavRefContext));
};
module.exports["useSideNavRef"] = $a4e20473d9b39975$export$fa4d0cff03b1ea4f;

});

parcelRegister("kF45k", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $e64534510941c49a$export$1cd490805a3a9874 = /*#__PURE__*/ (0, $42omo.createContext)({
    current: null
});
module.exports["SideNavRefContext"] = $e64534510941c49a$export$1cd490805a3a9874;

});

parcelRegister("9OYu5", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $1074d929e518961a$export$c41e1ac5602bc8d5 = /*#__PURE__*/ (0, $42omo.createContext)(false);
module.exports["IsSideNavShortcutEnabledContext"] = $1074d929e518961a$export$c41e1ac5602bc8d5;

});

parcelRegister("7R2w7", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $hEvVF = parcelRequire("hEvVF");

const $f8794fde192899a4$export$4a602ad7e09bdb2c = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(7);
    let t1;
    if ($[0] !== t0) {
        t1 = t0 === undefined ? {} : t0;
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const { defaultCollapsed: t2 } = t1;
    const defaultCollapsed = t2 === undefined ? false : t2;
    const sideNavState = (0, $42omo.useContext)((0, $hEvVF.SideNavVisibilityState));
    if (sideNavState === null) {
        const t3 = !defaultCollapsed;
        let t4;
        if ($[2] !== t3) {
            t4 = {
                isExpandedOnDesktop: t3,
                isExpandedOnMobile: false
            };
            $[2] = t3;
            $[3] = t4;
        } else t4 = $[3];
        return t4;
    }
    const t3 = sideNavState.desktop === "expanded";
    const t4 = sideNavState.mobile === "expanded";
    let t5;
    if ($[4] !== t3 || $[5] !== t4) {
        t5 = {
            isExpandedOnDesktop: t3,
            isExpandedOnMobile: t4
        };
        $[4] = t3;
        $[5] = t4;
        $[6] = t5;
    } else t5 = $[6];
    return t5;
} : ({ defaultCollapsed: defaultCollapsed = false } = {})=>{
    const sideNavState = (0, $42omo.useContext)((0, $hEvVF.SideNavVisibilityState));
    // If the context value is `null`, it means we are still in SSR, and should use the default values.
    // For desktop, it comes from the `defaultCollapsed` prop, and for mobile, it is always `false`.
    if (sideNavState === null) return {
        isExpandedOnDesktop: !defaultCollapsed,
        isExpandedOnMobile: false
    };
    return {
        isExpandedOnDesktop: sideNavState.desktop === 'expanded',
        isExpandedOnMobile: sideNavState.mobile === 'expanded'
    };
};
module.exports["useSideNavVisibility"] = $f8794fde192899a4$export$4a602ad7e09bdb2c;

});

parcelRegister("cFYM0", function(module, exports) {
/* side-nav-content.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $3654r = parcelRequire("3654r");


var $8zs3p = parcelRequire("8zs3p");

const $9c1f04fccaeb1d16$export$28f21f3651df4fa1 = /*#__PURE__*/ (0, $42omo.forwardRef)($9c1f04fccaeb1d16$var$_SideNavContent); // Placing this const below the function breaks Compiled!
const $9c1f04fccaeb1d16$var$styles = {
    scrollContainer: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo1wug _18m91wug",
    paddingContainer: "_1q51utpp _y4tiutpp _85i5utpp _bozgutpp"
};
function $9c1f04fccaeb1d16$var$_SideNavContent({ children: children, testId: testId }, forwardedRef) {
    const isFhsEnabled = (0, $8zs3p.useIsFhsEnabled)();
    const internalRef = (0, $42omo.useRef)(null);
    const mergedRef = (0, $42omo.useMemo)(()=>(0, $3654r.default)([
            internalRef,
            forwardedRef
        ]), [
        forwardedRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        ref: isFhsEnabled ? mergedRef : forwardedRef,
        "data-testid": testId,
        className: (0, $gMc0m.default)([
            $9c1f04fccaeb1d16$var$styles.scrollContainer
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            $9c1f04fccaeb1d16$var$styles.paddingContainer
        ])
    }, children));
}
module.exports["SideNavBody"] = $9c1f04fccaeb1d16$export$28f21f3651df4fa1;

});

parcelRegister("lxWrw", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $7f0c92f6dc95d81f$var$styles = {
    root: "_1q51utpp _y4tiutpp _85i5utpp _bozgutpp _7myae4h9 _1sw7nqa1 _qgnu1l7x"
}; /**
    * The bottom part of the side nav.
    */ 
const $7f0c92f6dc95d81f$export$b773c4c9cf740fbe = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(5);
    const { children: children, xcss: xcss } = t0;
    let t1;
    if ($[0] !== xcss) {
        t1 = (0, $gMc0m.default)([
            $7f0c92f6dc95d81f$var$styles.root,
            xcss
        ]);
        $[0] = xcss;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== children || $[3] !== t1) {
        t2 = /*#__PURE__*/ $42omo.createElement("div", {
            className: t1
        }, children);
        $[2] = children;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ children: /**
   * The content of the layout area.
   */ children, xcss: xcss })=>{
    return /*#__PURE__*/ $42omo.createElement("div", {
        className: (0, $gMc0m.default)([
            $7f0c92f6dc95d81f$var$styles.root,
            xcss
        ])
    }, children);
};
module.exports["SideNavFooter"] = $7f0c92f6dc95d81f$export$b773c4c9cf740fbe;

});

parcelRegister("9h7KX", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $7d7fc7efd35bb802$var$styles = {
    root: "_18zrutpp _1q51utpp _85i51b66"
}; /**
    * The top part of the side nav.
    */ 
const $7d7fc7efd35bb802$export$9d28ff3a0d89869c = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(3);
    const { children: children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $gMc0m.default)([
            $7d7fc7efd35bb802$var$styles.root
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== children) {
        t2 = /*#__PURE__*/ $42omo.createElement("div", {
            className: t1
        }, children);
        $[1] = children;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : ({ children: children })=>{
    return /*#__PURE__*/ $42omo.createElement("div", {
        className: (0, $gMc0m.default)([
            $7d7fc7efd35bb802$var$styles.root
        ])
    }, children);
};
module.exports["SideNavHeader"] = $7d7fc7efd35bb802$export$9d28ff3a0d89869c;

});

parcelRegister("2SvFZ", function(module, exports) {
/**
 * @generated — manual edits won't persist!
 * Shim sources: platform/build/monorepo-utils/deprecation-removal-recovery/index.js
 * Regenerate: node platform/build/monorepo-utils/deprecation-removal-recovery/generate-shims.js
 */ var $c952becf5b946e27$exports = {};
$parcel$export($c952becf5b946e27$exports, "SideNav", () => (parcelRequire("1fdQV")).SideNav);
$parcel$export($c952becf5b946e27$exports, "SideNavHeader", () => (parcelRequire("9h7KX")).SideNavHeader);
$parcel$export($c952becf5b946e27$exports, "SideNavBody", () => (parcelRequire("cFYM0")).SideNavBody);
$parcel$export($c952becf5b946e27$exports, "SideNavFooter", () => (parcelRequire("lxWrw")).SideNavFooter);
$parcel$export($c952becf5b946e27$exports, "SideNavToggleButton", () => (parcelRequire("9S2JE")).SideNavToggleButton);
$parcel$export($c952becf5b946e27$exports, "useToggleSideNav", () => (parcelRequire("622t3")).useToggleSideNav);
$parcel$export($c952becf5b946e27$exports, "useExpandSideNav", () => (parcelRequire("1cuAd")).useExpandSideNav);
$parcel$export($c952becf5b946e27$exports, "SideNavPanelSplitter", () => (parcelRequire("4hWZe")).SideNavPanelSplitter);

var $1fdQV = parcelRequire("1fdQV");


var $9h7KX = parcelRequire("9h7KX");


var $cFYM0 = parcelRequire("cFYM0");


var $lxWrw = parcelRequire("lxWrw");


var $9S2JE = parcelRequire("9S2JE");


var $622t3 = parcelRequire("622t3");


var $1cuAd = parcelRequire("1cuAd");


var $4hWZe = parcelRequire("4hWZe");



module.exports = Object.assign({}, $c952becf5b946e27$exports, {
    SideNavContent: $c952becf5b946e27$exports.SideNavBody
});
if ($c952becf5b946e27$exports.__esModule) Object.defineProperty(module.exports, '__esModule', {
    value: true
});

});

parcelRegister("3Znsn", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $ee7An = parcelRequire("ee7An");

const $6e559d0979924c5e$export$fb8fa9a80240785e = /*#__PURE__*/ (0, $42omo.createContext)((0, $ee7An.default));
module.exports["SideNavToggleButtonAttachRef"] = $6e559d0979924c5e$export$fb8fa9a80240785e;

});

parcelRegister("fFc6D", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");


var $bNwbD = parcelRequire("bNwbD");


var $bWLcG = parcelRequire("bWLcG");

const $1487a997836a60f3$var$queries = {
    'above.xxs': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $bWLcG.UNSAFE_media).above.xxs.replace('@media ', '').trim()),
    'above.xs': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $bWLcG.UNSAFE_media).above.xs.replace('@media ', '').trim()),
    'above.sm': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $bWLcG.UNSAFE_media).above.sm.replace('@media ', '').trim()),
    'above.md': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $bWLcG.UNSAFE_media).above.md.replace('@media ', '').trim()),
    'above.lg': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $bWLcG.UNSAFE_media).above.lg.replace('@media ', '').trim()),
    'above.xl': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $bWLcG.UNSAFE_media).above.xl.replace('@media ', '').trim()),
    'below.xs': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $bWLcG.UNSAFE_media).below.xs.replace('@media ', '').trim()),
    'below.sm': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $bWLcG.UNSAFE_media).below.sm.replace('@media ', '').trim()),
    'below.md': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $bWLcG.UNSAFE_media).below.md.replace('@media ', '').trim()),
    'below.lg': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $bWLcG.UNSAFE_media).below.lg.replace('@media ', '').trim()),
    'below.xl': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $bWLcG.UNSAFE_media).below.xl.replace('@media ', '').trim())
};
const $1487a997836a60f3$export$49e55ae2c03d6045 = (queryString, listener)=>{
    const listenerRef = (0, $42omo.useRef)(listener);
    (0, $42omo.useEffect)(()=>{
        // Bind the listener if changed so it's called on the next change event; no guarantee on timing.
        listenerRef.current = listener;
    }, [
        listener
    ]);
    /**
   * We explicitly only react to boolean changes for binding our listener
   * Changes to the functional reference are ignored.
   */ const hasListener = !!listener;
    /**
   * The `matchMedia(…)` return value for our breakpoint query.
   */ const mq = $1487a997836a60f3$var$queries[queryString];
    (0, $bNwbD.useLayoutEffect)(()=>{
        listenerRef.current = listener; // Bind the listener now in case the `useEffect` hasn't fired above yet
        if (!mq || !hasListener || !listenerRef.current) return;
        return (0, $fFa3V.bind)(mq, {
            type: 'change',
            listener: (event)=>{
                // We explicitly call the current version of the function
                return listenerRef.current(event);
            }
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps -- explicitly do not trigger the effect on `listener` reference change, only on a boolean representation of it.
    [
        mq,
        hasListener
    ]);
    return mq || null;
};
module.exports["UNSAFE_useMediaQuery"] = $1487a997836a60f3$export$49e55ae2c03d6045;

});

parcelRegister("bNwbD", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $95c4b21f9fd4bea1$export$e5c5a5f917a5871c = typeof window === 'undefined' ? (0, $42omo.useEffect) : (0, $42omo.useLayoutEffect);
module.exports["useLayoutEffect"] = $95c4b21f9fd4bea1$export$e5c5a5f917a5871c;

});

parcelRegister("l0s1Q", function(module, exports) {

var $3CnSH = parcelRequire("3CnSH");


var $bSwyQ = parcelRequire("bSwyQ");

/**
 * Set a `style` property on a `HTMLElement`
 *
 * @returns a `cleanup` function to restore the `style` property to it's original state
 */ function $781e3b2f1e0ef26e$var$setStyle(el, { property: property, rule: rule, priority: priority = '' }) {
    const originalValue = el.style.getPropertyValue(property);
    const originalPriority = el.style.getPropertyPriority(property);
    el.style.setProperty(property, rule, priority);
    return function cleanup() {
        el.style.setProperty(property, originalValue, originalPriority);
    };
}
let $781e3b2f1e0ef26e$var$isActive = false;
/**
 * Start blocking dragging to iframes. Only to be called once a drag has started.
 */ function $781e3b2f1e0ef26e$var$tryStart() {
    // There can technically be multiple registrations on the same element.
    // Adding a guard to ensure that only one registration does the blocking.
    if ($781e3b2f1e0ef26e$var$isActive) return;
    $781e3b2f1e0ef26e$var$isActive = true;
    // At this stage, we are also not watching for new iframe elements being added to the page
    // (we _could_ do that as a future change)
    const iframeCleanups = Array.from(document.querySelectorAll('iframe')).map((iframe)=>$781e3b2f1e0ef26e$var$setStyle(iframe, {
            property: 'pointer-events',
            rule: 'none',
            priority: 'important'
        }));
    // Not returning the cleanup function.
    // This code will clean itself up when the interaction ends in `onDrop()`.
    // Once a drag has started we are blocking iframes until the interaction is finished.
    const cleanup = (0, $bSwyQ.combine)(...iframeCleanups, // We only need this monitor for listening to the drop
    // as our monitor in `blockDraggingToIFrames()` will only
    // call this function when the drag has started
    (0, $3CnSH.monitorForElements)({
        onDrop () {
            cleanup();
        }
    }), function release() {
        $781e3b2f1e0ef26e$var$isActive = false;
    });
}
function $781e3b2f1e0ef26e$export$6ae1d8fab001518c({ element: element }) {
    return (0, $3CnSH.monitorForElements)({
        onGenerateDragPreview ({ source: source }) {
            // only starting if we are dragging the provided element
            if (source.element === element) $781e3b2f1e0ef26e$var$tryStart();
        }
    });
}
module.exports["blockDraggingToIFrames"] = $781e3b2f1e0ef26e$export$6ae1d8fab001518c;

});

parcelRegister("6UUmP", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $iHNqU = parcelRequire("iHNqU");

const $99f6c5f63009a988$export$750f5b0d6c51617e = (0, $4pOgL.isReactCompilerActivePlatform)() ? function useOpenLayerObserver() {
    const $ = (0, $frIzR.c)(4);
    const context = (0, $42omo.useContext)((0, $iHNqU.OpenLayerObserverContext));
    let t0;
    bb0: {
        if (context === null) {
            t0 = null;
            break bb0;
        }
        let t1;
        if ($[0] !== context.closeLayers || $[1] !== context.getCount || $[2] !== context.onChange) {
            t1 = {
                getCount: context.getCount,
                onChange: context.onChange,
                closeLayers: context.closeLayers
            };
            $[0] = context.closeLayers;
            $[1] = context.getCount;
            $[2] = context.onChange;
            $[3] = t1;
        } else t1 = $[3];
        t0 = t1;
    }
    const publicAPI = t0;
    return publicAPI;
} : function useOpenLayerObserver() {
    const context = (0, $42omo.useContext)((0, $iHNqU.OpenLayerObserverContext));
    const publicAPI = (0, $42omo.useMemo)(()=>{
        if (context === null) return null;
        return {
            getCount: context.getCount,
            onChange: context.onChange,
            closeLayers: context.closeLayers
        };
    }, [
        context
    ]);
    return publicAPI;
};
module.exports["useOpenLayerObserver"] = $99f6c5f63009a988$export$750f5b0d6c51617e;

});

parcelRegister("1cuAd", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");


var $jTxSS = parcelRequire("jTxSS");


var $dh538 = parcelRequire("dh538");


var $1w9Ty = parcelRequire("1w9Ty");


var $ijWqx = parcelRequire("ijWqx");

/**
 * Moves focus to the first focusable item in the side nav, or the side nav element itself as a fallback.
 */ function $63281e74cccc9d52$var$focusFirstNavItem(sideNavElement) {
    /**
   * Try to get the first focusable item in the side nav.
   * The selector is not very broad, but should be appropriate for items from this package.
   */ const firstNavItem = sideNavElement.querySelector('a, button');
    const isFirstNavItemVisible = firstNavItem !== null && (firstNavItem.checkVisibility?.() ?? false);
    const itemToFocus = isFirstNavItemVisible ? firstNavItem : sideNavElement;
    if (itemToFocus === sideNavElement) {
        /**
     * Elements without an explicit `tabindex` attribute are not guaranteed to be focusable:
     * https://html.spec.whatwg.org/multipage/interaction.html#attr-tabindex
     *
     * Our slots are not interactive, so this is required.
     *
     * In the future we may want to check if there is an existing `tabindex` attribute,
     * as custom skip linked elements might already have one.
     */ sideNavElement.setAttribute('tabindex', '-1');
        /**
     * Cleanup the `tabindex` attribute we set when the slot or custom target loses focus.
     *
     * This is preferable to always having `tabindex="-1"` because always applying the tab index can:
     *
     * - mess with click events
     * - potentially cause a focus ring to be always visible
     */ (0, $fFa3V.bind)(sideNavElement, {
            type: 'blur',
            listener () {
                sideNavElement.removeAttribute('tabindex');
            },
            options: {
                once: true
            }
        });
    }
    /**
   * Not using `focusVisible` option because we don't want clicks on the toggle button to show a focus ring.
   */ itemToFocus.focus();
}
const $63281e74cccc9d52$var$triggersWithFocusOnExpand = new Set([
    'toggle-button',
    'skip-link'
]);
const $63281e74cccc9d52$export$e44b4744d8ff971a = (0, $4pOgL.isReactCompilerActivePlatform)() ? function useExpandSideNav(t0) {
    const $ = (0, $frIzR.c)(6);
    let t1;
    if ($[0] !== t0) {
        t1 = t0 === undefined ? {} : t0;
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const { trigger: t2 } = t1;
    const trigger = t2 === undefined ? "programmatic" : t2;
    const setSideNavState = (0, $42omo.useContext)((0, $1w9Ty.SetSideNavVisibilityState));
    const sideNavRef = (0, $ijWqx.useSideNavRef)();
    let t3;
    if ($[2] !== setSideNavState || $[3] !== sideNavRef || $[4] !== trigger) {
        t3 = ()=>{
            const { matches: isDesktop } = window.matchMedia("(min-width: 64rem)");
            const runUpdate = ()=>{
                if (isDesktop) setSideNavState((currentState)=>{
                    if (!currentState) return null;
                    if (currentState.desktop === "expanded" && currentState.flyout === "closed") return currentState;
                    return {
                        mobile: currentState.mobile,
                        desktop: "expanded",
                        flyout: "closed",
                        lastTrigger: trigger
                    };
                });
                else setSideNavState((currentState_0)=>{
                    if (!currentState_0) return null;
                    if (currentState_0.mobile === "expanded" && currentState_0.flyout === "closed") return currentState_0;
                    return {
                        desktop: currentState_0.desktop,
                        mobile: "expanded",
                        flyout: "closed",
                        lastTrigger: trigger
                    };
                });
            };
            if ($63281e74cccc9d52$var$triggersWithFocusOnExpand.has(trigger) && (0, $dh538.fg)("platform_dst_nav4_skip_link_a11y_1")) {
                (0, $jTxSS.flushSync)(runUpdate);
                const sideNavElement = sideNavRef.current;
                if (sideNavElement) $63281e74cccc9d52$var$focusFirstNavItem(sideNavElement);
            } else runUpdate();
        };
        $[2] = setSideNavState;
        $[3] = sideNavRef;
        $[4] = trigger;
        $[5] = t3;
    } else t3 = $[5];
    const expandSideNav = t3;
    return expandSideNav;
} : function useExpandSideNav({ trigger: trigger = 'programmatic' } = {}) {
    const setSideNavState = (0, $42omo.useContext)((0, $1w9Ty.SetSideNavVisibilityState));
    const sideNavRef = (0, $ijWqx.useSideNavRef)();
    const expandSideNav = (0, $42omo.useCallback)(()=>{
        const { matches: isDesktop } = window.matchMedia('(min-width: 64rem)');
        const runUpdate = ()=>{
            if (isDesktop) setSideNavState((currentState)=>{
                // No-op if the side nav state has not been initialised yet
                // e.g. if the SideNav has not been mounted yet
                if (!currentState) return null;
                // Skip the re-render if it's a no-op change
                if (currentState.desktop === 'expanded' && currentState.flyout === 'closed') return currentState;
                return {
                    mobile: currentState.mobile,
                    desktop: 'expanded',
                    flyout: 'closed',
                    lastTrigger: trigger
                };
            });
            else setSideNavState((currentState_0)=>{
                // No-op if the side nav state has not been initialised yet
                // e.g. if the SideNav has not been mounted yet
                if (!currentState_0) return null;
                // Skip the re-render if it's a no-op change
                if (currentState_0.mobile === 'expanded' && currentState_0.flyout === 'closed') return currentState_0;
                return {
                    desktop: currentState_0.desktop,
                    mobile: 'expanded',
                    flyout: 'closed',
                    lastTrigger: trigger
                };
            });
        };
        if ($63281e74cccc9d52$var$triggersWithFocusOnExpand.has(trigger) && (0, $dh538.fg)('platform_dst_nav4_skip_link_a11y_1')) {
            (0, $jTxSS.flushSync)(runUpdate);
            const sideNavElement = sideNavRef.current;
            if (sideNavElement) $63281e74cccc9d52$var$focusFirstNavItem(sideNavElement);
        } else runUpdate();
    }, [
        setSideNavState,
        sideNavRef,
        trigger
    ]);
    return expandSideNav;
};
module.exports["useExpandSideNav"] = $63281e74cccc9d52$export$e44b4744d8ff971a;

});

parcelRegister("622t3", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");


var $1w9Ty = parcelRequire("1w9Ty");


var $hEvVF = parcelRequire("hEvVF");


var $1cuAd = parcelRequire("1cuAd");

const $24bc66d44c50665e$export$477ee35601a0a8ce = (0, $4pOgL.isReactCompilerActivePlatform)() ? function useToggleSideNav(t0) {
    const $ = (0, $frIzR.c)(10);
    let t1;
    if ($[0] !== t0) {
        t1 = t0 === undefined ? {} : t0;
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const { trigger: t2 } = t1;
    const trigger = t2 === undefined ? "programmatic" : t2;
    const setSideNavState = (0, $42omo.useContext)((0, $1w9Ty.SetSideNavVisibilityState));
    const sideNavState = (0, $42omo.useContext)((0, $hEvVF.SideNavVisibilityState));
    let t3;
    if ($[2] !== trigger) {
        t3 = {
            trigger: trigger
        };
        $[2] = trigger;
        $[3] = t3;
    } else t3 = $[3];
    const expandSideNav = (0, $1cuAd.useExpandSideNav)(t3);
    const isCollapsedOnDesktop = sideNavState?.desktop === "collapsed";
    const isCollapsedOnMobile = sideNavState?.mobile === "collapsed";
    let t4;
    if ($[4] !== expandSideNav || $[5] !== isCollapsedOnDesktop || $[6] !== isCollapsedOnMobile || $[7] !== setSideNavState || $[8] !== trigger) {
        t4 = ()=>{
            const { matches: isDesktop } = window.matchMedia("(min-width: 64rem)");
            if ((0, $dh538.fg)("platform_dst_nav4_skip_link_a11y_1")) {
                const isExpanding = isDesktop ? isCollapsedOnDesktop : isCollapsedOnMobile;
                if (isExpanding) expandSideNav();
                else setSideNavState((currentState)=>{
                    if (!currentState) return null;
                    return {
                        mobile: isDesktop ? currentState.mobile : "collapsed",
                        desktop: isDesktop ? "collapsed" : currentState.desktop,
                        flyout: "closed",
                        lastTrigger: trigger
                    };
                });
                return;
            }
            if (isDesktop) setSideNavState((currentState_0)=>{
                if (!currentState_0) return null;
                return {
                    mobile: currentState_0.mobile,
                    desktop: currentState_0.desktop === "expanded" ? "collapsed" : "expanded",
                    flyout: "closed",
                    lastTrigger: trigger
                };
            });
            else setSideNavState((currentState_1)=>{
                if (!currentState_1) return null;
                return {
                    desktop: currentState_1.desktop,
                    mobile: currentState_1.mobile === "expanded" ? "collapsed" : "expanded",
                    flyout: "closed",
                    lastTrigger: trigger
                };
            });
        };
        $[4] = expandSideNav;
        $[5] = isCollapsedOnDesktop;
        $[6] = isCollapsedOnMobile;
        $[7] = setSideNavState;
        $[8] = trigger;
        $[9] = t4;
    } else t4 = $[9];
    const toggleSideNav = t4;
    return toggleSideNav;
} : function useToggleSideNav({ trigger: trigger = 'programmatic' } = {}) {
    const setSideNavState = (0, $42omo.useContext)((0, $1w9Ty.SetSideNavVisibilityState));
    const sideNavState = (0, $42omo.useContext)((0, $hEvVF.SideNavVisibilityState));
    const expandSideNav = (0, $1cuAd.useExpandSideNav)({
        trigger: trigger
    });
    const isCollapsedOnDesktop = sideNavState?.desktop === 'collapsed';
    const isCollapsedOnMobile = sideNavState?.mobile === 'collapsed';
    const toggleSideNav = (0, $42omo.useCallback)(()=>{
        const { matches: isDesktop } = window.matchMedia('(min-width: 64rem)');
        if ((0, $dh538.fg)('platform_dst_nav4_skip_link_a11y_1')) {
            const isExpanding = isDesktop ? isCollapsedOnDesktop : isCollapsedOnMobile;
            if (isExpanding) expandSideNav();
            else setSideNavState((currentState)=>{
                // No-op if the side nav state has not been initialised yet
                // e.g. if the SideNav has not been mounted yet
                if (!currentState) return null;
                return {
                    mobile: isDesktop ? currentState.mobile : 'collapsed',
                    desktop: isDesktop ? 'collapsed' : currentState.desktop,
                    flyout: 'closed',
                    lastTrigger: trigger
                };
            });
            return;
        }
        if (isDesktop) setSideNavState((currentState_0)=>{
            // No-op if the side nav state has not been initialised yet
            // e.g. if the SideNav has not been mounted yet
            if (!currentState_0) return null;
            return {
                mobile: currentState_0.mobile,
                desktop: currentState_0.desktop === 'expanded' ? 'collapsed' : 'expanded',
                flyout: 'closed',
                lastTrigger: trigger
            };
        });
        else setSideNavState((currentState_1)=>{
            // No-op if the side nav state has not been initialised yet
            // e.g. if the SideNav has not been mounted yet
            if (!currentState_1) return null;
            return {
                desktop: currentState_1.desktop,
                mobile: currentState_1.mobile === 'expanded' ? 'collapsed' : 'expanded',
                flyout: 'closed',
                lastTrigger: trigger
            };
        });
    }, [
        expandSideNav,
        isCollapsedOnDesktop,
        isCollapsedOnMobile,
        setSideNavState,
        trigger
    ]);
    return toggleSideNav;
};
module.exports["useToggleSideNav"] = $24bc66d44c50665e$export$477ee35601a0a8ce;

});

parcelRegister("1D5qM", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $157e7ae57519d2bd$export$7a4054f2c546f2cd = /*#__PURE__*/ (0, $42omo.createContext)(null);
module.exports["PanelSplitterContext"] = $157e7ae57519d2bd$export$7a4054f2c546f2cd;

});

parcelRegister("5By30", function(module, exports) {

var $4YRks = parcelRequire("4YRks");

function $3f94ef21efd3ee5c$export$e239b3966b677000(data) {
    return data[0, $4YRks.panelSplitterDragDataSymbol] === true;
}
module.exports["isPanelSplitterDragData"] = $3f94ef21efd3ee5c$export$e239b3966b677000;

});

parcelRegister("9S2JE", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");


var $inPa6 = parcelRequire("inPa6");


var $3uA7H = parcelRequire("3uA7H");


var $cN7t9 = parcelRequire("cN7t9");


var $6UUmP = parcelRequire("6UUmP");


var $8zs3p = parcelRequire("8zs3p");


var $iVuOI = parcelRequire("iVuOI");


var $3Znsn = parcelRequire("3Znsn");


var $huiud = parcelRequire("huiud");


var $hEvVF = parcelRequire("hEvVF");


var $iCTy4 = parcelRequire("iCTy4");


var $7R2w7 = parcelRequire("7R2w7");


var $622t3 = parcelRequire("622t3");

const $31c01975bf558c1d$var$toggleButtonTooltipOptions = {
    // We're disabling pointer events on the tooltip to prevent it from blocking mouse events, so that the side nav flyout stays open
    // when moving the mouse from the top bar to the side nav.
    ignoreTooltipPointerEvents: true
}; // For duplicate "mouseenter" issue when changing icons (see below)
const $31c01975bf558c1d$var$silentIconStyles = null; /**
                                * __SideNavToggleButton__
                                *
                                * Button for toggling the side nav. It should be used in the top bar.
                                */ 
const $31c01975bf558c1d$export$8bd77667631fec25 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(36);
    const { defaultCollapsed: t1, expandLabel: expandLabel, collapseLabel: collapseLabel, testId: testId, interactionName: interactionName, onClick: onClick } = t0;
    const defaultCollapsed = t1 === undefined ? false : t1;
    const isFhsEnabled = (0, $8zs3p.useIsFhsEnabled)();
    let t2;
    if ($[0] !== defaultCollapsed) {
        t2 = {
            defaultCollapsed: defaultCollapsed
        };
        $[0] = defaultCollapsed;
        $[1] = t2;
    } else t2 = $[1];
    const { isExpandedOnDesktop: isSideNavExpandedOnDesktop, isExpandedOnMobile: isSideNavExpandedOnMobile } = (0, $7R2w7.useSideNavVisibility)(t2);
    const sideNavState = (0, $42omo.useContext)((0, $hEvVF.SideNavVisibilityState));
    const [isSideNavExpanded, setIsSideNavExpanded] = (0, $42omo.useState)(sideNavState === null ? !defaultCollapsed : isSideNavExpandedOnDesktop);
    const ref = (0, $42omo.useContext)((0, $3Znsn.SideNavToggleButtonAttachRef));
    const [element, setElement] = (0, $42omo.useState)(null);
    let t3;
    let t4;
    if ($[2] !== element || $[3] !== ref) {
        t3 = ()=>{
            ref(element);
        };
        t4 = [
            element,
            ref
        ];
        $[2] = element;
        $[3] = ref;
        $[4] = t3;
        $[5] = t4;
    } else {
        t3 = $[4];
        t4 = $[5];
    }
    (0, $42omo.useEffect)(t3, t4);
    let t5;
    let t6;
    if ($[6] !== isSideNavExpandedOnDesktop || $[7] !== isSideNavExpandedOnMobile) {
        t5 = ()=>{
            const { matches: matches } = window.matchMedia("(min-width: 64rem)");
            setIsSideNavExpanded(matches ? isSideNavExpandedOnDesktop : isSideNavExpandedOnMobile);
        };
        t6 = [
            isSideNavExpandedOnDesktop,
            isSideNavExpandedOnMobile
        ];
        $[6] = isSideNavExpandedOnDesktop;
        $[7] = isSideNavExpandedOnMobile;
        $[8] = t5;
        $[9] = t6;
    } else {
        t5 = $[8];
        t6 = $[9];
    }
    (0, $42omo.useEffect)(t5, t6);
    let t7;
    let t8;
    if ($[10] !== isSideNavExpandedOnDesktop || $[11] !== isSideNavExpandedOnMobile) {
        t7 = ()=>{
            const mediaQueryList = window.matchMedia("(min-width: 64rem)");
            return (0, $fFa3V.bind)(mediaQueryList, {
                type: "change",
                listener () {
                    setIsSideNavExpanded(mediaQueryList.matches ? isSideNavExpandedOnDesktop : isSideNavExpandedOnMobile);
                }
            });
        };
        t8 = [
            isSideNavExpandedOnDesktop,
            isSideNavExpandedOnMobile
        ];
        $[10] = isSideNavExpandedOnDesktop;
        $[11] = isSideNavExpandedOnMobile;
        $[12] = t7;
        $[13] = t8;
    } else {
        t7 = $[12];
        t8 = $[13];
    }
    (0, $42omo.useEffect)(t7, t8);
    let t9;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = {
            trigger: "toggle-button"
        };
        $[14] = t9;
    } else t9 = $[14];
    const toggleVisibility = (0, $622t3.useToggleSideNav)(t9);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const openLayerObserver = (0, $6UUmP.useOpenLayerObserver)();
    let t10;
    if ($[15] !== isFhsEnabled || $[16] !== isSideNavExpanded || $[17] !== onClick || $[18] !== openLayerObserver || $[19] !== toggleVisibility) {
        t10 = (event, analyticsEvent)=>{
            onClick?.(event, analyticsEvent, {
                isSideNavVisible: isSideNavExpanded
            });
            toggleVisibility();
            if (isFhsEnabled) openLayerObserver?.closeLayers();
        };
        $[15] = isFhsEnabled;
        $[16] = isSideNavExpanded;
        $[17] = onClick;
        $[18] = openLayerObserver;
        $[19] = toggleVisibility;
        $[20] = t10;
    } else t10 = $[20];
    const handleClick = t10;
    let t11;
    if ($[21] !== createAnalyticsEvent || $[22] !== isSideNavExpanded) {
        t11 = ()=>{
            const isDesktop = window.matchMedia("(min-width: 64rem)").matches;
            if (!isDesktop) return;
            const navigationAnalyticsEvent = createAnalyticsEvent({
                source: "topNav",
                actionSubject: "sideNav",
                action: "hovered",
                actionSubjectId: "sideNavButton",
                attributes: {
                    itemState: isSideNavExpanded ? "expanded" : "collapsed",
                    screen: "desktop"
                }
            });
            navigationAnalyticsEvent.fire("navigation");
        };
        $[21] = createAnalyticsEvent;
        $[22] = isSideNavExpanded;
        $[23] = t11;
    } else t11 = $[23];
    const handlePointerEnter = t11;
    let t12;
    if ($[24] !== isSideNavExpanded) {
        t12 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
                className: (0, $gMc0m.default)([
                    "_1e0c1bgi _lcxvglyw"
                ])
            }, isSideNavExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3uA7H))), props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cN7t9))), props));
        $[24] = isSideNavExpanded;
        $[25] = t12;
    } else t12 = $[25];
    const icon = t12;
    const isShortcutEnabled = (0, $iCTy4.useIsSideNavShortcutEnabled)();
    let t13;
    bb0: {
        if (isFhsEnabled) {
            const t14 = isShortcutEnabled ? (0, $huiud.sideNavToggleTooltipKeyboardShortcut) : undefined;
            let t15;
            if ($[26] !== t14) {
                t15 = {
                    ...$31c01975bf558c1d$var$toggleButtonTooltipOptions,
                    shortcut: t14
                };
                $[26] = t14;
                $[27] = t15;
            } else t15 = $[27];
            t13 = t15;
            break bb0;
        }
        t13 = $31c01975bf558c1d$var$toggleButtonTooltipOptions;
    }
    const tooltipProps = t13;
    const t14 = isSideNavExpanded ? collapseLabel : expandLabel;
    let t15;
    if ($[28] !== handleClick || $[29] !== handlePointerEnter || $[30] !== icon || $[31] !== interactionName || $[32] !== t14 || $[33] !== testId || $[34] !== tooltipProps) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iVuOI.IconButton), {
            appearance: "subtle",
            label: t14,
            icon: icon,
            onClick: handleClick,
            onPointerEnter: handlePointerEnter,
            testId: testId,
            isTooltipDisabled: false,
            interactionName: interactionName,
            ref: setElement,
            tooltip: tooltipProps
        });
        $[28] = handleClick;
        $[29] = handlePointerEnter;
        $[30] = icon;
        $[31] = interactionName;
        $[32] = t14;
        $[33] = testId;
        $[34] = tooltipProps;
        $[35] = t15;
    } else t15 = $[35];
    return t15;
} : ({ defaultCollapsed: defaultCollapsed = false, expandLabel: expandLabel, collapseLabel: collapseLabel, testId: testId, interactionName: interactionName, onClick: onClick })=>{
    const isFhsEnabled = (0, $8zs3p.useIsFhsEnabled)();
    const { isExpandedOnDesktop: isSideNavExpandedOnDesktop, isExpandedOnMobile: isSideNavExpandedOnMobile } = (0, $7R2w7.useSideNavVisibility)({
        defaultCollapsed: defaultCollapsed
    });
    const sideNavState = (0, $42omo.useContext)((0, $hEvVF.SideNavVisibilityState)); // When default state is provided to `Root` the state in context will already be
    // initialized in SSR
    const [isSideNavExpanded, setIsSideNavExpanded] = (0, $42omo.useState)(sideNavState === null ? !defaultCollapsed : isSideNavExpandedOnDesktop);
    const ref = (0, $42omo.useContext)((0, $3Znsn.SideNavToggleButtonAttachRef)); /**
                                                         * Addresses HOT-121458 by ensuring that the toggle button element in context is always up to date.
                                                         *
                                                         * My theory is that something to do with SSR, hydration and suspense was causing the
                                                         * underlying HTML element to change but without causing the toggle button to remount.
                                                         *
                                                         * This meant the effect calling `ref()` did not re-run, and the value in context became stale.
                                                         */ 
    const [element, setElement] = (0, $42omo.useState)(null);
    (0, $42omo.useEffect)(()=>{
        ref(element);
    }, [
        element,
        ref
    ]);
    (0, $42omo.useEffect)(()=>{
        const { matches: matches } = window.matchMedia('(min-width: 64rem)');
        setIsSideNavExpanded(matches ? isSideNavExpandedOnDesktop : isSideNavExpandedOnMobile);
    }, [
        isSideNavExpandedOnDesktop,
        isSideNavExpandedOnMobile
    ]);
    (0, $42omo.useEffect)(()=>{
        // When screen size changes, ensure we use the correct visibility state
        const mediaQueryList = window.matchMedia('(min-width: 64rem)');
        return (0, $fFa3V.bind)(mediaQueryList, {
            type: 'change',
            listener () {
                setIsSideNavExpanded(mediaQueryList.matches ? isSideNavExpandedOnDesktop : isSideNavExpandedOnMobile);
            }
        });
    }, [
        isSideNavExpandedOnDesktop,
        isSideNavExpandedOnMobile
    ]);
    const toggleVisibility = (0, $622t3.useToggleSideNav)({
        trigger: 'toggle-button'
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const openLayerObserver = (0, $6UUmP.useOpenLayerObserver)();
    const handleClick = (0, $42omo.useCallback)((event, analyticsEvent)=>{
        onClick?.(event, analyticsEvent, {
            isSideNavVisible: isSideNavExpanded
        });
        toggleVisibility();
        if (isFhsEnabled) openLayerObserver?.closeLayers();
    }, [
        isFhsEnabled,
        isSideNavExpanded,
        onClick,
        openLayerObserver,
        toggleVisibility
    ]);
    const handlePointerEnter = (0, $42omo.useCallback)(()=>{
        // Hovers don't do anything on mobile, so not capturing
        const isDesktop = window.matchMedia('(min-width: 64rem)').matches;
        if (!isDesktop) return;
        const navigationAnalyticsEvent = createAnalyticsEvent({
            source: 'topNav',
            actionSubject: 'sideNav',
            action: 'hovered',
            actionSubjectId: 'sideNavButton',
            attributes: {
                itemState: isSideNavExpanded ? 'expanded' : 'collapsed',
                screen: 'desktop'
            }
        });
        navigationAnalyticsEvent.fire('navigation');
    }, [
        createAnalyticsEvent,
        isSideNavExpanded
    ]); /**
                                                  * ## Behaviour
                                                  * It is intentional that collapse icon will be used while the flyout is open.
                                                  * The icon is tied to the expanded / collapse state, and not the flyout state.
                                                  *
                                                  * ## Why a function?
                                                  * Unfortunately, changing the icon inside an <IconButton> when the user is over
                                                  * the button will cause the svg element to be replaced, which can trigger a
                                                  * "mouseenter" event. This is problematic when the user is already over the button,
                                                  * as it can result in a "mouseenter" event after the user manually entered the button.
                                                  *
                                                  * `icon` accepts a function for the `icon` prop (ie a render prop), so we don't need to
                                                  * memoize it, or pull it out into a new function
                                                  */ 
    const icon = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
            className: (0, $gMc0m.default)([
                "_1e0c1bgi _lcxvglyw"
            ])
        }, isSideNavExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3uA7H))), props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cN7t9))), props));
    const isShortcutEnabled = (0, $iCTy4.useIsSideNavShortcutEnabled)();
    const tooltipProps = (0, $42omo.useMemo)(()=>{
        if (isFhsEnabled) return {
            ...$31c01975bf558c1d$var$toggleButtonTooltipOptions,
            shortcut: isShortcutEnabled ? (0, $huiud.sideNavToggleTooltipKeyboardShortcut) : undefined
        };
        return $31c01975bf558c1d$var$toggleButtonTooltipOptions;
    }, [
        isFhsEnabled,
        isShortcutEnabled
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iVuOI.IconButton), {
        appearance: "subtle",
        label: isSideNavExpanded ? collapseLabel : expandLabel,
        icon: icon,
        onClick: handleClick,
        onPointerEnter: handlePointerEnter,
        testId: testId,
        isTooltipDisabled: false,
        interactionName: interactionName,
        ref: setElement,
        tooltip: tooltipProps
    });
};
module.exports["SideNavToggleButton"] = $31c01975bf558c1d$export$8bd77667631fec25;

});

parcelRegister("4hWZe", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $dRnqM = parcelRequire("dRnqM");


var $6UUmP = parcelRequire("6UUmP");


var $8zs3p = parcelRequire("8zs3p");


var $K0HEo = parcelRequire("K0HEo");


var $622t3 = parcelRequire("622t3");


var $2KODV = parcelRequire("2KODV");


var $bssir = parcelRequire("bssir");


var $1D5qM = parcelRequire("1D5qM");

/**
 * Namespaces to check for open layers that would interfere with the panel splitter.
 *
 * Placed outside the component for stability, as the list is used as an effect dependency.
 */ const $e0197539f2395191$var$openLayerNamespacesToCheck = [
    // The side nav panel splitter is layered above the side nav, so needs to be disabled when there are open popups in the side nav.
    (0, $K0HEo.openLayerObserverSideNavNamespace),
    // The side nav panel splitter is layered above the top nav, so needs to be disabled when there are open popups in the top nav.
    (0, $K0HEo.openLayerObserverTopNavStartNamespace),
    (0, $K0HEo.openLayerObserverTopNavMiddleNamespace),
    (0, $K0HEo.openLayerObserverTopNavEndNamespace)
];
/**
 * Returns whether there are any open popups in the side nav or top nav
 */ const $e0197539f2395191$var$useHasOpenPopupsInSideNavOrTopNav = (0, $4pOgL.isReactCompilerActivePlatform)() ? function useHasOpenPopupsInSideNavOrTopNav() {
    const $ = (0, $frIzR.c)(4);
    const isFhsEnabled = (0, $8zs3p.useIsFhsEnabled)();
    const openLayerObserver = (0, $6UUmP.useOpenLayerObserver)();
    const [hasOpenPopups, setHasOpenPopups] = (0, $42omo.useState)(false);
    let t0;
    let t1;
    if ($[0] !== isFhsEnabled || $[1] !== openLayerObserver) {
        t0 = ()=>{
            if (!openLayerObserver || !isFhsEnabled) return;
            const updateState = function updateState() {
                if (!openLayerObserver) return;
                const hasAnyOpenLayers = $e0197539f2395191$var$openLayerNamespacesToCheck.some((namespace)=>openLayerObserver.getCount({
                        namespace: namespace,
                        type: "popup"
                    }) > 0);
                setHasOpenPopups(hasAnyOpenLayers);
            };
            updateState();
            const cleanups = $e0197539f2395191$var$openLayerNamespacesToCheck.map((namespace_0)=>openLayerObserver.onChange(updateState, {
                    namespace: namespace_0
                }));
            return function cleanupHook() {
                cleanups.forEach($e0197539f2395191$var$_temp);
            };
        };
        t1 = [
            isFhsEnabled,
            openLayerObserver
        ];
        $[0] = isFhsEnabled;
        $[1] = openLayerObserver;
        $[2] = t0;
        $[3] = t1;
    } else {
        t0 = $[2];
        t1 = $[3];
    }
    (0, $42omo.useEffect)(t0, t1);
    return hasOpenPopups;
} : function useHasOpenPopupsInSideNavOrTopNav() {
    const isFhsEnabled = (0, $8zs3p.useIsFhsEnabled)();
    const openLayerObserver = (0, $6UUmP.useOpenLayerObserver)();
    // Setting the initial state to false, as it is unlikely that there would be any open popups when the app starts.
    const [hasOpenPopups, setHasOpenPopups] = (0, $42omo.useState)(false);
    (0, $42omo.useEffect)(()=>{
        if (!openLayerObserver || !isFhsEnabled) return;
        function updateState() {
            if (!openLayerObserver) return;
            const hasAnyOpenLayers = $e0197539f2395191$var$openLayerNamespacesToCheck.some((namespace)=>openLayerObserver.getCount({
                    namespace: namespace,
                    type: 'popup'
                }) > 0);
            setHasOpenPopups(hasAnyOpenLayers);
        }
        // Initial check. We do this _in case_ a popup is already open when the component mounts.
        updateState();
        // Subscribe to each namespace
        const cleanups = $e0197539f2395191$var$openLayerNamespacesToCheck.map((namespace_0)=>openLayerObserver.onChange(updateState, {
                namespace: namespace_0
            }));
        return function cleanupHook() {
            cleanups.forEach((cleanup)=>cleanup());
        };
    }, [
        isFhsEnabled,
        openLayerObserver
    ]);
    return hasOpenPopups;
};
function $e0197539f2395191$var$_temp(cleanup) {
    return cleanup();
}
const $e0197539f2395191$export$5f595addf4e50d58 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(10);
    const { label: label, onResizeStart: onResizeStart, onResizeEnd: onResizeEnd, testId: testId, shouldCollapseOnDoubleClick: t1, tooltipContent: tooltipContent } = t0;
    const shouldCollapseOnDoubleClick = t1 === undefined ? true : t1;
    const context = (0, $42omo.useContext)((0, $1D5qM.PanelSplitterContext));
    (0, $dRnqM.default)(context?.panelId === (0, $K0HEo.sideNavPanelSplitterId), "SideNavPanelSplitter must be rendered as a child of <SideNav />.");
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {
            trigger: "double-click"
        };
        $[0] = t2;
    } else t2 = $[0];
    const toggleSideNav = (0, $622t3.useToggleSideNav)(t2);
    const isFhsEnabled = (0, $8zs3p.useIsFhsEnabled)();
    const hasOpenLayersInSideNavOrTopNav = $e0197539f2395191$var$useHasOpenPopupsInSideNavOrTopNav();
    if (hasOpenLayersInSideNavOrTopNav && isFhsEnabled) return null;
    const t3 = shouldCollapseOnDoubleClick ? toggleSideNav : undefined;
    const t4 = shouldCollapseOnDoubleClick ? tooltipContent : undefined;
    let t5;
    if ($[1] !== label || $[2] !== onResizeEnd || $[3] !== onResizeStart || $[4] !== t4 || $[5] !== testId) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bssir.PanelSplitter), {
            label: label,
            onResizeStart: onResizeStart,
            onResizeEnd: onResizeEnd,
            testId: testId,
            tooltipContent: t4
        });
        $[1] = label;
        $[2] = onResizeEnd;
        $[3] = onResizeStart;
        $[4] = t4;
        $[5] = testId;
        $[6] = t5;
    } else t5 = $[6];
    let t6;
    if ($[7] !== t3 || $[8] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2KODV.OnDoubleClickContext).Provider, {
            value: t3
        }, t5);
        $[7] = t3;
        $[8] = t5;
        $[9] = t6;
    } else t6 = $[9];
    return t6;
} : ({ label: label, onResizeStart: onResizeStart, onResizeEnd: onResizeEnd, testId: testId, shouldCollapseOnDoubleClick: shouldCollapseOnDoubleClick = true, tooltipContent: tooltipContent })=>{
    const context = (0, $42omo.useContext)((0, $1D5qM.PanelSplitterContext));
    (0, $dRnqM.default)(context?.panelId === (0, $K0HEo.sideNavPanelSplitterId), 'SideNavPanelSplitter must be rendered as a child of <SideNav />.');
    const toggleSideNav = (0, $622t3.useToggleSideNav)({
        trigger: 'double-click'
    });
    const isFhsEnabled = (0, $8zs3p.useIsFhsEnabled)();
    // The logic and state for disabling the panel splitter when there are open popups
    // in the side nav or top nav is being placed here, instead of in `SideNav`, to prevent
    // re-rendering the side nav anytime the number of open popups changes.
    const hasOpenLayersInSideNavOrTopNav = $e0197539f2395191$var$useHasOpenPopupsInSideNavOrTopNav();
    if (hasOpenLayersInSideNavOrTopNav && isFhsEnabled) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2KODV.OnDoubleClickContext).Provider, {
        value: shouldCollapseOnDoubleClick ? toggleSideNav : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bssir.PanelSplitter), {
        label: label,
        onResizeStart: onResizeStart,
        onResizeEnd: onResizeEnd,
        testId: testId,
        tooltipContent: // Only displaying the tooltip if double click to collapse is enabled.
        // Otherwise, we would be displaying a tooltip with "Double click to collapse", when it actually won't.
        shouldCollapseOnDoubleClick ? tooltipContent : undefined
    }));
};
module.exports["SideNavPanelSplitter"] = $e0197539f2395191$export$5f595addf4e50d58;

});

parcelRegister("4YRks", function(module, exports) {
const $9ddd696ba22f6816$export$64f49ceb7f6e9a23 = Symbol('panel-splitter-drag-data');
module.exports["panelSplitterDragDataSymbol"] = $9ddd696ba22f6816$export$64f49ceb7f6e9a23;

});

parcelRegister("huiud", function(module, exports) {
/**
 * The keyboard shortcut used in tooltips for indicating how to toggle the side nav.
 *
 * Used in `SideNavToggleButton` and `SideNavPanelSplitter` tooltips.
 */ const $3ce0a5d7f35b6a1f$export$bcd616a79072c3e4 = [
    'Ctrl',
    '['
];
module.exports["sideNavToggleTooltipKeyboardShortcut"] = $3ce0a5d7f35b6a1f$export$bcd616a79072c3e4;

});

parcelRegister("iCTy4", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $42omo = parcelRequire("42omo");


var $9OYu5 = parcelRequire("9OYu5");

const $7f575981784a2be0$export$be30cdcd17f95ec7 = (0, $4pOgL.isReactCompilerActivePlatform)() ? function useIsSideNavShortcutEnabled() {
    return (0, $42omo.useContext)((0, $9OYu5.IsSideNavShortcutEnabledContext));
} : function useIsSideNavShortcutEnabled() {
    return (0, $42omo.useContext)((0, $9OYu5.IsSideNavShortcutEnabledContext));
};
module.exports["useIsSideNavShortcutEnabled"] = $7f575981784a2be0$export$be30cdcd17f95ec7;

});

parcelRegister("2KODV", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $5d5b8d3d75211efe$export$e253efba824eceb = /*#__PURE__*/ (0, $42omo.createContext)(undefined);
module.exports["OnDoubleClickContext"] = $5d5b8d3d75211efe$export$e253efba824eceb;

});


//# sourceMappingURL=top-nav-items.8092574f.js.map
